/**
 *
 * BIGTINCAN - CONFIDENTIAL
 *
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of BigTinCan Mobile Pty Ltd and its suppliers,
 * if any. The intellectual and technical concepts contained herein are proprietary to BigTinCan Mobile Pty Ltd and its
 * suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or reproduction of this material is strictly forbidden unless prior
 * written permission is obtained from BigTinCan Mobile Pty Ltd.
 *
 * @package style-guide
 * @copyright 2010-2018 BigTinCan Mobile Pty Ltd
 * @author Lochlan McBride <lochlan.mcbride@bigtincan.com>
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './SVGIcon.less';

const UsdzSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-3d-model">
      <g fill="#FFAA32" id="svg_1" transform="translate(0 512) scale(0.1 -0.1)">
        <path
          d="m2522,5106c-226,-126 -648,-376 -658,-392c-8,-11 -17,-41 -20,-65c-8,-62 21,-96 89,-105c46,-7 51,-5 266,119c120,70 225,128 232,129c12,2 15,-53 19,-300l5,-304l37,-34c52,-47 88,-46 139,5l39,39l0,295c0,163 4,298 8,301c4,2 109,-54 232,-125c222,-129 226,-130 275,-125c69,7 99,42 92,103c-2,23 -11,53 -19,65c-13,19 -535,330 -657,391c-40,20 -47,20 -79,3z"
          id="svg_2"
        />
        <path
          d="m995,4223c-37,-20 -582,-334 -612,-353c-12,-8 -26,-25 -32,-37c-16,-34 -15,-777 0,-806c33,-63 104,-84 154,-45c51,40 55,65 55,337c0,137 3,252 8,254c4,3 34,-11 67,-30c33,-20 146,-85 250,-145c186,-107 191,-109 240,-104c70,8 100,42 91,105c-3,25 -12,54 -19,64c-7,11 -123,83 -258,161c-144,83 -244,147 -244,156c0,9 91,67 219,141c225,130 238,141 250,209c16,86 -82,139 -169,93z"
          id="svg_3"
        />
        <path
          d="m4012,4233c-35,-7 -64,-60 -56,-103c12,-68 25,-79 250,-209c128,-74 219,-132 219,-141c0,-9 -100,-73 -244,-156c-135,-78 -251,-150 -258,-161c-7,-10 -15,-39 -18,-64c-5,-37 -2,-49 18,-73c21,-26 31,-30 78,-30c52,-1 65,5 299,141c135,78 248,139 252,137c5,-3 8,-118 8,-255c0,-272 4,-297 55,-337c50,-39 121,-18 154,45c16,31 15,772 -1,808c-8,18 -97,75 -332,211c-326,189 -355,202 -424,187z"
          id="svg_4"
        />
        <path
          d="m1952,2983c-36,-7 -64,-60 -56,-108c3,-22 12,-49 19,-60c7,-11 114,-78 237,-149c124,-71 240,-141 259,-157l34,-28l5,-306l5,-307l37,-34c26,-23 47,-34 68,-34c21,0 42,11 68,34l37,34l5,307l5,306l35,29c19,16 137,88 261,159c155,90 229,138 237,155c45,99 4,166 -103,166c-12,0 -120,-56 -239,-125c-120,-69 -238,-134 -262,-144c-44,-20 -44,-20 -88,0c-24,10 -142,75 -262,144c-218,126 -233,131 -302,118z"
          id="svg_5"
        />
        <path
          d="m389,2137c-15,-12 -32,-32 -38,-44c-15,-29 -16,-772 0,-806c13,-28 -9,-14 334,-212c323,-187 338,-195 362,-195c74,0 131,53 119,108c-18,75 -20,77 -257,213c-126,73 -229,135 -229,139c0,4 113,72 250,151c138,79 257,153 264,165c8,11 17,41 21,66c9,63 -20,96 -90,104c-49,5 -54,3 -240,-104c-104,-60 -217,-125 -250,-145c-33,-19 -63,-33 -67,-30c-5,2 -8,117 -8,254c0,272 -4,297 -55,337c-35,28 -83,27 -116,-1z"
          id="svg_6"
        />
        <path
          d="m4615,2138c-51,-40 -55,-65 -55,-337c0,-137 -3,-252 -7,-254c-5,-3 -118,59 -253,137c-234,135 -247,141 -299,140c-46,0 -57,-4 -78,-29c-22,-25 -24,-35 -19,-74c3,-25 12,-54 19,-64c7,-11 123,-83 258,-161c140,-81 244,-147 244,-156c0,-8 -94,-69 -219,-141c-120,-70 -222,-133 -227,-140c-5,-8 -14,-31 -20,-53c-20,-72 27,-126 109,-126c19,0 117,50 283,146c376,216 406,234 418,261c16,34 15,776 0,806c-33,63 -104,84 -154,45z"
          id="svg_7"
        />
        <path
          d="m2492,966l-37,-34l-3,-299c-2,-164 -6,-301 -10,-305c-4,-4 -109,51 -232,123c-222,128 -226,130 -275,125c-70,-8 -100,-41 -91,-105c3,-24 12,-54 20,-65c11,-17 491,-301 653,-387l41,-22l44,21c24,12 178,99 343,195c254,147 303,179 317,208c41,79 9,144 -75,155c-47,7 -51,5 -267,-119c-120,-70 -225,-128 -232,-129c-10,-2 -14,57 -18,300l-5,304l-37,34c-50,45 -86,45 -136,0z"
          id="svg_8"
        />
      </g>
      <line
        fill="none"
        id="svg_22"
        stroke="#cccccc"
        strokeWidth="10"
        x1="254.5"
        x2="254.5"
        y1="96.49999"
        y2="240.5"
      />
      <line
        fill="none"
        id="svg_11"
        stroke="#cccccc"
        strokeWidth="10"
        x1="113.5"
        x2="186.5"
        y1="94.5"
        y2="52.5"
      />
      <line
        fill="none"
        id="svg_12"
        stroke="#cccccc"
        strokeWidth="10"
        x1="322.5"
        x2="398.5"
        y1="51.5"
        y2="96.5"
      />
      <line
        fill="none"
        id="svg_13"
        stroke="#cccccc"
        strokeWidth="10"
        x1="466.5"
        x2="466.5"
        y1="214.5"
        y2="298.5"
      />
      <line
        fill="none"
        id="svg_14"
        stroke="#cccccc"
        strokeWidth="10"
        x1="324.5"
        x2="401.5"
        y1="461.5"
        y2="415.5"
      />
      <line
        fill="none"
        id="svg_15"
        stroke="#cccccc"
        strokeWidth="10"
        x1="112.5"
        x2="187.5"
        y1="417.5"
        y2="460.5"
      />
      <line
        fill="none"
        id="svg_16"
        stroke="#cccccc"
        strokeWidth="10"
        x1="255.5"
        x2="255.5"
        y1="331.5"
        y2="412.5"
      />
      <line
        fill="none"
        id="svg_17"
        stroke="#cccccc"
        strokeWidth="10"
        x1="319.5"
        x2="391.5"
        y1="219.5"
        y2="178.5"
      />
      <line
        fill="none"
        id="svg_18"
        stroke="#cccccc"
        strokeWidth="10"
        x1="115.5"
        x2="245.5"
        y1="334.5"
        y2="261.5"
      />
      <line
        fill="none"
        id="svg_19"
        stroke="#cccccc"
        strokeWidth="10"
        x1="266.5"
        x2="395.5"
        y1="264.5"
        y2="338.5"
      />
      <line
        fill="none"
        id="svg_20"
        stroke="#cccccc"
        strokeWidth="10"
        x1="115.5"
        x2="193.5"
        y1="173.5"
        y2="221.5"
      />
      <line
        fill="none"
        id="svg_21"
        stroke="#cccccc"
        strokeWidth="10"
        x1="45.5"
        x2="44.5"
        y1="211.5"
        y2="298.5"
      />
    </g>
  </svg>
);

const BtcSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-app" transform="translate(32, 36)">
      <path
        d="M189,307.301587 C274.051851,307.301587 343,238.509784 343,153.650794 C343,68.7918035 274.051851,0 189,0 C103.948149,0 35,68.7918035 35,153.650794 C35,238.509784 103.948149,307.301587 189,307.301587 L189,307.301587 Z M189,296.058846 C110.171455,296.058846 46.2682927,232.300589 46.2682927,153.650794 C46.2682927,75.0009979 110.171455,11.242741 189,11.242741 C267.828545,11.242741 331.731707,75.0009979 331.731707,153.650794 C331.731707,232.300589 267.828545,296.058846 189,296.058846 L189,296.058846 Z"
        fill="#B7B7A5"
      />
      <path
        d="M182,405.079365 C282.515824,405.079365 364,323.779961 364,223.492063 C364,123.204166 282.515824,41.9047619 182,41.9047619 C81.4841755,41.9047619 0,123.204166 0,223.492063 C0,323.779961 81.4841755,405.079365 182,405.079365 L182,405.079365 Z M182,375.12682 C98.0641053,375.12682 30.0206186,307.237627 30.0206186,223.492063 C30.0206186,139.7465 98.0641053,71.8573065 182,71.8573065 C265.935895,71.8573065 333.979381,139.7465 333.979381,223.492063 C333.979381,307.237627 265.935895,375.12682 182,375.12682 L182,375.12682 Z"
        fill="#B7B7A5"
      />
      <path
        d="M259,440 C363.381818,440 448,355.573696 448,251.428571 C448,147.283447 363.381818,62.8571429 259,62.8571429 C154.618182,62.8571429 70,147.283447 70,251.428571 C70,355.573696 154.618182,440 259,440 L259,440 Z M259,391.45686 C181.488749,391.45686 118.653465,328.76406 118.653465,251.428571 C118.653465,174.093083 181.488749,111.400283 259,111.400283 C336.511251,111.400283 399.346535,174.093083 399.346535,251.428571 C399.346535,328.76406 336.511251,391.45686 259,391.45686 L259,391.45686 Z"
        fill="#F26724"
      />
    </g>
  </svg>
);

const CadSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-dxf" transform="translate(24.000000, 36.000000)">
      <path
        d="M1.91735537,310.81321 L34.5123958,325.358851 L291.43803,325.358851 L148.285197,411.524975 C99.733924,440.156555 74.7392795,445.063732 61.6284034,422.977608 L1.91735537,310.81321 L1.91735537,310.81321 Z"
        id="Fill-8"
        fill="#D62526"
      />
      <path
        d="M107.30285,325.358852 L24.4838757,325.358852 C7.06756618,325.358852 -4.76698385,307.704104 1.87469985,291.632536 L117.139557,12.684474 C120.311705,5.00833119 127.807428,0 136.126689,0 L246.29781,0 L107.30285,325.358852 L107.30285,325.358852 Z"
        id="Fill-10"
        fill="#F06061"
      />
      <path
        d="M281.038056,13.5272727 C277.579147,5.3320574 269.533924,0 260.622056,0 L137.819279,0 C137.819279,0 151.068205,0 158.499874,16.4478469 L336.495643,437.875599 L460.17657,437.875599 L281.038056,13.5272727 L281.038056,13.5272727 Z"
        id="Fill-12"
        fill="#D62526"
      />
    </g>
  </svg>
);

const ExcelSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-excel" transform="translate(0, 104)">
      <path
        d="M336.4,112 L199.6,112 C195.401,112 192,108.931429 192,105.142857 L192,70.8571429 C192,67.0685714 195.401,64 199.6,64 L336.4,64 C340.599,64 344,67.0685714 344,70.8571429 L344,105.142857 C344,108.931429 340.599,112 336.4,112"
        fill="#DDDDDD"
      />
      <path
        d="M504.4,112 L367.6,112 C363.401,112 360,108.931429 360,105.142857 L360,70.8571429 C360,67.0685714 363.401,64 367.6,64 L504.4,64 C508.599,64 512,67.0685714 512,70.8571429 L512,105.142857 C512,108.931429 508.599,112 504.4,112"
        fill="#DDDDDD"
      />
      <path
        d="M336.4,176 L199.6,176 C195.401,176 192,172.931429 192,169.142857 L192,134.857143 C192,131.068571 195.401,128 199.6,128 L336.4,128 C340.599,128 344,131.068571 344,134.857143 L344,169.142857 C344,172.931429 340.599,176 336.4,176"
        fill="#DDDDDD"
      />
      <path
        d="M504.4,176 L367.6,176 C363.401,176 360,172.931429 360,169.142857 L360,134.857143 C360,131.068571 363.401,128 367.6,128 L504.4,128 C508.599,128 512,131.068571 512,134.857143 L512,169.142857 C512,172.931429 508.599,176 504.4,176"
        fill="#DDDDDD"
      />
      <path
        d="M336.4,242 L199.6,242 C195.401,242 192,238.931429 192,235.142857 L192,200.857143 C192,197.068571 195.401,194 199.6,194 L336.4,194 C340.599,194 344,197.068571 344,200.857143 L344,235.142857 C344,238.931429 340.599,242 336.4,242"
        fill="#DDDDDD"
      />
      <path
        d="M504.4,242 L367.6,242 C363.401,242 360,238.931429 360,235.142857 L360,200.857143 C360,197.068571 363.401,194 367.6,194 L504.4,194 C508.599,194 512,197.068571 512,200.857143 L512,235.142857 C512,238.931429 508.599,242 504.4,242"
        fill="#DDDDDD"
      />
      <path
        d="M336.4,304 L199.6,304 C195.401,304 192,300.931429 192,297.142857 L192,262.857143 C192,259.068571 195.401,256 199.6,256 L336.4,256 C340.599,256 344,259.068571 344,262.857143 L344,297.142857 C344,300.931429 340.599,304 336.4,304"
        fill="#DDDDDD"
      />
      <path
        d="M504.4,304 L367.6,304 C363.401,304 360,300.931429 360,297.142857 L360,262.857143 C360,259.068571 363.401,256 367.6,256 L504.4,256 C508.599,256 512,259.068571 512,262.857143 L512,297.142857 C512,300.931429 508.599,304 504.4,304"
        fill="#DDDDDD"
      />
      <path
        d="M336.4,48 L199.6,48 C195.401,48 192,44.9314286 192,41.1428571 L192,6.85714286 C192,3.06857143 195.401,0 199.6,0 L336.4,0 C340.599,0 344,3.06857143 344,6.85714286 L344,41.1428571 C344,44.9314286 340.599,48 336.4,48"
        fill="#DDDDDD"
      />
      <path
        d="M504.4,48 L367.6,48 C363.401,48 360,44.9314286 360,41.1428571 L360,6.85714286 C360,3.06857143 363.401,0 367.6,0 L504.4,0 C508.599,0 512,3.06857143 512,6.85714286 L512,41.1428571 C512,44.9314286 508.599,48 504.4,48"
        fill="#DDDDDD"
      />
      <path
        d="M5.1547036,56 L54.5497382,56 L92.5438271,117.31328 L131.893599,56 L178.573383,56 L116.425604,147.6992 L184,248 L133.253167,248 L90.9162304,181.57952 L47.7635535,248 L0,248 L67.5743962,147.4304 L5.1547036,56"
        fill="#07872C"
      />
    </g>
  </svg>
);

const FolderSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-folder" transform="translate(0, 40)">
      <rect
        fillOpacity="0.25"
        x="4.65454545"
        y="78.9677419"
        width="502.690909"
        height="348.387097"
        rx="6"
      />
      <path d="M0,99.8709677 L1.32290139e-13,413.408775 C1.32290139e-13,423.664613 8.32786262,432 18.6008017,432 L493.399198,432 C503.645703,432 512,423.676424 512,413.408775 L512,99.8709677 L507.345455,99.8709677 L507.345455,413.428629 C507.345455,421.119862 501.080576,427.354839 493.37596,427.354839 L18.6240387,427.354839 C10.9089006,427.354839 4.65454545,421.104221 4.65454545,413.428629 L4.65454545,99.8709677 L0,99.8709677 L0,99.8709677 Z" />
      <path d="M146.618182,0 C169.890909,0 169.890909,37.1612903 193.163636,37.1612903 L493.372544,37.1612903 C503.660204,37.1612903 512,45.4744988 512,55.7215221 L512,99.8709677 L507.345455,99.8709677 C507.345455,88.2580645 498.036364,78.9677419 486.4,78.9677419 L25.6,78.9677419 C13.9636364,78.9677419 4.65454545,88.2580645 4.65454545,99.8709677 L0,99.8709677 L0,18.5753515 C0,8.31646814 8.32618121,0 18.6256916,0 L146.618182,0 L146.618182,0 Z M18.6256916,4.64516129 C10.9010237,4.64516129 4.65454545,10.8777214 4.65454545,18.5753515 L4.65454545,85.9354839 C4.65454545,85.9354839 11.3930019,74.3225806 25.6,74.3225806 L486.4,74.3225806 C500.606997,74.3225806 507.345455,85.9354839 507.345455,85.9354839 L507.345455,55.7215221 C507.345455,48.0402648 501.08988,41.8064516 493.372544,41.8064516 L193.163636,41.8064516 C167.563636,41.8064516 165.236364,4.64516129 146.618182,4.64516129 L18.6256916,4.64516129 L18.6256916,4.64516129 Z" />
      <path
        fillOpacity="0.45"
        d="M18.6256916,4.64516129 C10.9010237,4.64516129 4.65454545,10.8777214 4.65454545,18.5753515 L4.65454545,85.9354839 C4.65454545,85.9354839 11.3930019,74.3225806 25.6,74.3225806 L486.4,74.3225806 C500.606997,74.3225806 507.345455,85.9354839 507.345455,85.9354839 L507.345455,55.7215221 C507.345455,48.0402648 501.08988,41.8064516 493.372544,41.8064516 L193.163636,41.8064516 C167.563636,41.8064516 165.236364,4.64516129 146.618182,4.64516129 L18.6256916,4.64516129 L18.6256916,4.64516129 Z"
      />
    </g>
  </svg>
);

const PowerpointSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-powerpoint" transform="translate(0, 96)">
      <path
        d="M344,16 C260.0542,16 192,84.0542 192,168 C192,251.9458 260.0542,320 344,320 C427.9458,320 496,251.9458 496,168 L344,168 L344,16"
        fill="#DDDDDD"
      />
      <path
        d="M360,0 C443.9458,0 512,67.8516577 512,151.547619 L360,151.547619 L360,0"
        fill="#F26724"
      />
      <path
        d="M86.0195257,64 C126.421885,64 152,87.31648 152,125.57824 C152,157.024 133.319011,186.79168 86.4963734,186.79168 L41.3713138,186.88 L41.3713138,256 L0,256 L0,64 L86.0195257,64 L86.0195257,64 L86.0195257,64 Z M73.9648137,156.16 C108.847183,156.16 110.037395,138.24256 110.037395,127.38688 C110.037395,116.16256 108.603037,98.56 73.9648137,98.56 L41.3713138,98.56 L41.3713138,156.16 L73.9648137,156.16 L73.9648137,156.16 L73.9648137,156.16 Z"
        fill="#F26724"
      />
    </g>
  </svg>
);

const ProjectSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-project" transform="translate(0, 64)">
      <path
        d="M86.0195257,96 C126.421885,96 152,119.31648 152,157.57824 C152,189.024 133.319011,218.79168 86.4963734,218.79168 L41.9626051,218.88 L41.9626051,288 L0,288 L0,96 L86.0195257,96 L86.0195257,96 L86.0195257,96 Z M74.5522901,188.16 C109.438474,188.16 110.628686,170.24256 110.628686,159.38688 C110.628686,148.16256 109.190513,130.56 74.5522901,130.56 L41.9626051,130.56 L41.9626051,188.16 L74.5522901,188.16 L74.5522901,188.16 L74.5522901,188.16 Z"
        fill="#17A149"
      />
      <path
        d="M256,32 L384,32 L384,144 L416,144 L416,-2.84217094e-14 L256,-2.84217094e-14 L256,26.4444444 L256,32 Z"
        fill="#DDDDDD"
      />
      <path d="M400,248 L288,144 L512,144 L400,248" fill="#DDDDDD" />
      <path d="M276,384 L192,300 L276,216 L360,300 L276,384" fill="#DDDDDD" />
    </g>
  </svg>
);

const ScrollmotionSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-scrollmotion" transform="translate(28.000000, 36.000000)">
      <path
        d="M301.367867,311.774413 L301.367867,311.774413 C296.763533,311.774413 293.0522,308.093074 293.0522,303.567965 L293.083867,220.68472 C293.083867,216.147111 296.807867,212.478272 301.399533,212.478272 C305.997533,212.478272 309.708867,216.153361 309.708867,220.68472 L309.683533,303.567965 C309.683533,308.111825 305.9532,311.774413 301.367867,311.774413"
        id="Fill-1"
        fill="#0098BC"
      />
      <path
        d="M263.169,163.007706 C261.775667,163.007706 260.312667,162.657698 258.995333,161.895179 L186.301333,120.437931 C182.349333,118.156626 180.987667,113.144006 183.280333,109.218911 C185.579333,105.318817 190.639667,103.943784 194.629667,106.231339 L267.33,147.694838 C271.301,149.969892 272.669,154.982513 270.37,158.913858 C268.837333,161.532671 266.038,163.007706 263.169,163.007706"
        id="Fill-3"
        fill="#0098BC"
      />
      <path
        d="M157.4625,436.571166 C154.9735,436.571166 152.5605,435.958653 150.419833,434.727375 C145.7205,432.05856 143.0225,426.883435 143.0225,420.602032 L143.066833,306.124277 C143.066833,301.599168 146.797167,297.917829 151.369833,297.917829 C155.967833,297.917829 159.6855,301.617918 159.6855,306.124277 L159.653833,418.85199 L265.718167,358.538039 C269.670167,356.269234 274.7685,357.625517 277.0675,361.550611 C279.372833,365.481956 278.004833,370.494577 274.0275,372.763381 L166.588833,433.996106 C163.5615,435.696146 160.451833,436.571166 157.4625,436.571166"
        id="Fill-5"
        fill="#0098BC"
      />
      <path
        d="M112.405267,248.015378 C111.011933,248.015378 109.5616,247.646619 108.2696,246.902851 L8.68426665,190.188986 C3.1426,187.007659 -0.0114,182.107541 0.00126666667,176.757412 C0.00126666667,171.401034 3.1616,166.513416 8.66526665,163.36959 L108.256933,106.649474 C112.2216,104.38067 117.2946,105.718202 119.606267,109.662047 C121.905267,113.574641 120.530933,118.599762 116.559933,120.868567 L18.5199333,176.701161 L116.5726,232.683759 C120.5436,234.952563 121.9116,239.965184 119.618933,243.890279 C118.079933,246.540342 115.274267,248.015378 112.405267,248.015378"
        id="Fill-7"
        fill="#0098BC"
      />
      <path
        d="M301.326067,355.927351 C299.901067,355.927351 298.457067,355.571092 297.1714,354.827325 L185.742733,291.338296 C181.759067,289.063241 180.410067,284.050621 182.6964,280.119276 C184.982733,276.206682 190.093733,274.862899 194.0584,277.112953 L301.326067,338.251925 L434.630065,262.343848 L335.678067,205.848738 C331.681733,203.579933 330.3264,198.554812 332.612733,194.635968 C334.9054,190.710873 340.0164,189.373341 343.9874,191.629645 L444.4594,248.887274 C449.9884,252.0311 453.174065,256.931218 453.174065,262.281346 C453.174065,267.650226 450.0074,272.525343 444.4594,275.681669 L305.4744,354.827325 C304.2014,355.571092 302.770067,355.927351 301.326067,355.927351"
        id="Fill-9"
        fill="#00C9CA"
      />
      <path
        d="M159.656367,96.1085957 L159.7007,248.056004 L293.055367,172.079175 L293.087033,20.1317665 L159.656367,96.1085957 L159.656367,96.1085957 Z M151.391367,270.456543 C149.966367,270.456543 148.522367,270.119035 147.243033,269.369017 C144.678033,267.912732 143.082033,265.200167 143.082033,262.262596 L143.025033,91.3647315 C143.012367,88.2521565 144.8047,85.4208385 147.623033,84.0270546 L286.1647,5.06265365 C289.179367,3.36261274 292.2257,2.48759167 295.240367,2.48759167 C302.435033,2.48759167 309.712033,7.9752238 309.712033,18.4692264 L309.680367,176.823039 C309.680367,179.754359 308.097033,182.454424 305.519367,183.93571 L155.546033,269.369017 C154.279367,270.119035 152.8417,270.456543 151.391367,270.456543 L151.391367,270.456543 L151.391367,270.456543 Z"
        id="Fill-11"
        fill="#00C9CA"
      />
    </g>
  </svg>
);

const WordSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-word" transform="translate(0, 128)">
      <path
        d="M150.959551,232 L120.001827,101.31328 L119.49031,101.31328 L89.0404494,232 L48.3602539,232 L-2.84217094e-14,40 L40.1723324,40 L69.0839892,170.68672 L69.595506,170.68672 L101.320505,40 L138.935254,40 L170.152389,172.30336 L170.660252,172.30336 L200.594943,40 L240,40 L190.872471,232 L150.959551,232"
        fill="#3EA2D9"
      />
      <path
        d="M505.4,16 L254.6,16 C250.9535,16 248,12.42 248,8 C248,3.58 250.9535,0 254.6,0 L505.4,0 C509.0465,0 512,3.58 512,8 C512,12.42 509.0465,16 505.4,16"
        fill="#DDDDDD"
      />
      <path
        d="M505.4,64 L254.6,64 C250.9535,64 248,60.42 248,56 C248,51.58 250.9535,48 254.6,48 L505.4,48 C509.0465,48 512,51.58 512,56 C512,60.42 509.0465,64 505.4,64"
        fill="#DDDDDD"
      />
      <path
        d="M505.4,112 L254.6,112 C250.9535,112 248,108.42 248,104 C248,99.58 250.9535,96 254.6,96 L505.4,96 C509.0465,96 512,99.58 512,104 C512,108.42 509.0465,112 505.4,112"
        fill="#DDDDDD"
      />
      <path
        d="M505.4,160 L254.6,160 C250.9535,160 248,156.42 248,152 C248,147.58 250.9535,144 254.6,144 L505.4,144 C509.0465,144 512,147.58 512,152 C512,156.42 509.0465,160 505.4,160"
        fill="#DDDDDD"
      />
      <path
        d="M505.4,208 L254.6,208 C250.9535,208 248,204.42 248,200 C248,195.58 250.9535,192 254.6,192 L505.4,192 C509.0465,192 512,195.58 512,200 C512,204.42 509.0465,208 505.4,208"
        fill="#DDDDDD"
      />
      <path
        d="M505.4,256 L254.6,256 C250.9535,256 248,252.42 248,248 C248,243.58 250.9535,240 254.6,240 L505.4,240 C509.0465,240 512,243.58 512,248 C512,252.42 509.0465,256 505.4,256"
        fill="#DDDDDD"
      />
    </g>
  </svg>
);

const VisioSVG = props => (
  <svg
    viewBox="0 0 512 512"
    className={props.className}
    style={props.style}
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="icon-visio" transform="translate(0, 96)">
      <path
        d="M61.5982997,256 L0,64 L42.9314559,64 L85.333599,198.99136 L85.8667198,198.99136 L128.798176,64 L172,64 L108.79853,256 L61.5982997,256"
        id="Fill-4"
        fill="#38549E"
      />
      <g id="Group" transform="translate(200, 0)" fill="#DDDDDD">
        <path d="M230.048297,160.330743 L154.117125,83.2223092 L154.117125,94.1270884 L230.048297,17.0186547 L219.310007,17.0186547 L295.24118,94.1270884 L295.24118,83.2223092 L219.310007,160.330743 L230.048297,160.330743 L230.048297,160.330743 Z M219.310007,171.235522 L224.679152,176.687912 L230.048297,171.235522 L305.979469,94.1270884 L311.348614,88.6746988 L305.979469,83.2223092 L230.048297,6.11387542 L224.679152,0.661485784 L219.310007,6.11387542 L143.378835,83.2223092 L138.00969,88.6746988 L143.378835,94.1270884 L219.310007,171.235522 L219.310007,171.235522 Z M8.27531134,212.048193 L114.578952,212.048193 L106.985835,204.337349 L106.985835,312.289157 L114.578952,304.578313 L8.27531134,304.578313 L15.8684286,312.289157 L15.8684286,204.337349 L8.27531134,212.048193 L8.27531134,212.048193 Z M8.27531134,196.626506 L0.682194125,196.626506 L0.682194125,204.337349 L0.682194125,312.289157 L0.682194125,320 L8.27531134,320 L114.578952,320 L122.17207,320 L122.17207,312.289157 L122.17207,204.337349 L122.17207,196.626506 L114.578952,196.626506 L8.27531134,196.626506 L8.27531134,196.626506 Z" />
        <path d="M57.6305732,96.3855422 L148.74798,96.3855422 L148.74798,80.9638554 L57.6305732,80.9638554 L57.6305732,96.3855422 L57.6305732,96.3855422 Z M217.086035,165.783133 L217.086035,258.313253 L224.679152,250.60241 L114.286617,250.60241 L114.286617,266.024096 L224.679152,266.024096 L232.272269,266.024096 L232.272269,258.313253 L232.272269,165.783133 L217.086035,165.783133 L217.086035,165.783133 Z" />
      </g>
    </g>
  </svg>
);

const Toolbox = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 230 116"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <rect id="a" width="126" height="8" rx="4" />
      <path
        id="b"
        d="M112.84 0H117a2 2 0 0 1 2 2v34h-11l2.847-34.166A2 2 0 0 1 112.84 0z"
      />
      <path
        id="c"
        d="M11.84 0H16a2 2 0 0 1 2 2v34H7L9.847 1.834A2 2 0 0 1 11.84 0z"
      />
      <rect id="d" width="12" height="76" rx="2" />
      <path
        id="e"
        d="M5 62.19V17.01A9.001 9.001 0 0 1 8 0v8.897a1 1 0 1 0 2 0V0c4.5.497 8 4.313 8 8.945a9 9 0 0 1-5 8.065v45.18a6.999 6.999 0 0 1 3 5.75 7.003 7.003 0 0 1-7 7.005c-3.866 0-7-3.136-7-7.005a6.999 6.999 0 0 1 3-5.75zm4 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      />
      <path
        id="f"
        d="M15 13h7c.184 9.893.35 18.726.5 26.5.137 7.139.57 16.577 1.299 28.314A3 3 0 0 1 20.804 71h-4.589a3 3 0 0 1-2.993-3.201c.685-10.206 1.111-19.64 1.278-28.299.184-9.558.35-18.392.5-26.5z"
      />
      <rect id="g" width="6" height="12" x="31" y="1" rx="2" />
      <path
        id="h"
        d="M4 1h116v11l-1 2 1 1v29a3 3 0 0 1-3 3H9a5 5 0 0 1-5-5v-7l1-1-1-2V19l1-3-1-1V1z"
      />
      <path
        id="i"
        d="M3 0h118a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
      />
      <path
        id="j"
        d="M10.797 44.14A3.988 3.988 0 0 1 12 47v24a6 6 0 1 1-12 0V47c0-1.12.46-2.133 1.203-2.86A3.492 3.492 0 0 1 0 41.5V41a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v.5a3.492 3.492 0 0 1-1.203 2.64z"
      />
      <path
        id="k"
        d="M2.133 6.534L3.793.725A1 1 0 0 1 4.754 0h2.492a1 1 0 0 1 .961.725l1.66 5.809a2 2 0 0 1 .038.941L9 12v28H3V12l-.905-4.525a2 2 0 0 1 .038-.941z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#F7F7F7"
        fillOpacity=".9"
        d="M190.95 115.299c3.362-8.934 5.201-18.614 5.201-28.724C196.151 41.523 159.628 5 114.575 5 69.523 5 33 41.523 33 86.575c0 10.23 1.883 20.018 5.32 29.04 2.58-.316 150.25 0 152.63-.316z"
      />
      <g fill="#24283D" transform="translate(0 114)">
        <rect width="210" height="2" x="10" rx="1" />
        <rect width="4" height="2" x="4" rx="1" />
        <rect width="2" height="2" rx="1" />
        <rect width="4" height="2" x="222" rx="1" />
        <rect width="2" height="2" x="228" rx="1" />
      </g>
      <g transform="translate(59 41)">
        <use fill="#FFF" xlinkHref="#a" />
        <rect
          width="124"
          height="6"
          x="1"
          y="1"
          stroke="#24283D"
          strokeWidth="2"
          rx="3"
        />
        <path
          fill="#E5E5E5"
          d="M0 4h126a6.578 6.578 0 0 1-4.724 2H6.015A10 10 0 0 1 .348 4.24L0 4z"
        />
        <rect
          width="124"
          height="6"
          x="1"
          y="1"
          stroke="#24283D"
          strokeWidth="2"
          rx="3"
        />
      </g>
      <g transform="translate(59 35)">
        <use fill="#FFF" xlinkHref="#b" />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M109.087 35H118V2a1 1 0 0 0-1-1h-4.16a1 1 0 0 0-.996.917L109.087 35z"
        />
      </g>
      <path fill="#E5E5E5" d="M168 67h9v2h-9z" />
      <path
        stroke="#24283D"
        strokeWidth="2"
        d="M168.087 70H177V37a1 1 0 0 0-1-1h-4.16a1 1 0 0 0-.996.917L168.087 70z"
      />
      <g transform="matrix(-1 0 0 1 84 35)">
        <use fill="#FFF" xlinkHref="#c" />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M8.087 35H17V2a1 1 0 0 0-1-1h-4.16a1 1 0 0 0-.996.917L8.087 35z"
        />
      </g>
      <path fill="#E5E5E5" d="M68 67h7v2h-7z" />
      <path
        stroke="#24283D"
        strokeWidth="2"
        d="M75.913 70H67V37a1 1 0 0 1 1-1h4.16a1 1 0 0 1 .996.917L75.913 70z"
      />
      <g transform="rotate(4 -330.862 1630.822)">
        <use fill="#FF854B" xlinkHref="#d" />
        <rect
          width="10"
          height="74"
          x="1"
          y="1"
          stroke="#24283D"
          strokeWidth="2"
          rx="2"
        />
        <path fill="#000" fillOpacity=".15" d="M8 2h2v73H8z" />
        <rect
          width="10"
          height="74"
          x="1"
          y="1"
          stroke="#24283D"
          strokeWidth="2"
          rx="2"
        />
        <rect width="5" height="2" x="7" y="7" fill="#24283D" rx="1" />
        <rect width="5" height="2" x="7" y="19" fill="#24283D" rx="1" />
        <rect width="5" height="2" x="7" y="31" fill="#24283D" rx="1" />
        <rect width="5" height="2" x="7" y="43" fill="#24283D" rx="1" />
        <rect width="5" height="2" x="7" y="55" fill="#24283D" rx="1" />
        <rect width="5" height="2" x="7" y="67" fill="#24283D" rx="1" />
        <rect width="7" height="2" x="5" y="13" fill="#24283D" rx="1" />
        <rect width="7" height="2" x="5" y="25" fill="#24283D" rx="1" />
        <rect width="7" height="2" x="5" y="37" fill="#24283D" rx="1" />
        <rect width="7" height="2" x="5" y="49" fill="#24283D" rx="1" />
        <rect width="7" height="2" x="5" y="61" fill="#24283D" rx="1" />
      </g>
      <g>
        <g transform="rotate(-11 207.923 -394.006)">
          <use fill="#DDD" xlinkHref="#e" />
          <path
            stroke="#24283D"
            strokeWidth="2"
            d="M11 1.197v7.7a2 2 0 1 1-4 0v-7.7a8.006 8.006 0 0 0-6 7.748 8 8 0 0 0 4.445 7.169L6 16.39v46.322l-.428.298A5.998 5.998 0 0 0 3 67.94a6.003 6.003 0 0 0 6 6.005c3.314 0 6-2.688 6-6.005 0-1.99-.972-3.813-2.572-4.93L12 62.712V16.39l.555-.276A8 8 0 0 0 17 8.945a8.006 8.006 0 0 0-6-7.748zM9 69.94a2 2 0 1 1 0-4.001 2 2 0 0 1 0 4z"
          />
        </g>
        <path
          fill="#000"
          fillOpacity=".15"
          d="M94.395 38.225c-.438-2.254-1.95-4.553-4.535-6.895 4.512-.37 6.681 2.212 7.565 6.76a9 9 0 0 1-3.37 8.87l8.622 44.35a6.999 6.999 0 0 1 4.042 5.072 7.003 7.003 0 0 1-5.535 8.212c-.085-.436 3.46-3.163 2.601-7.58-.572-2.945-3.708-3.354-3.708-3.354-.382-1.964-9.092-47.25-9.357-48.613 5.017-3.012 3.776-6.306 3.675-6.822z"
        />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M90.026 31.51l1.47 7.56a2 2 0 1 1-3.927.763l-1.47-7.56a8.006 8.006 0 0 0-4.41 8.751 8 8 0 0 0 5.73 6.19l.598.164 8.839 45.471-.363.375a5.998 5.998 0 0 0-1.585 5.33 6.003 6.003 0 0 0 7.036 4.75 6.003 6.003 0 0 0 4.744-7.04 5.998 5.998 0 0 0-3.466-4.348l-.476-.211-8.84-45.471.493-.377a8 8 0 0 0 2.995-7.885 8.006 8.006 0 0 0-7.368-6.462zm11.154 67.863a2 2 0 1 1-.763-3.927 2 2 0 0 1 .763 3.927z"
        />
      </g>
      <g>
        <path
          fill="#DDD"
          stroke="#24283D"
          strokeWidth="2"
          d="M145.036 50.05l3.763.664a2 2 0 0 0 1.954-.779l1.191-1.606a2 2 0 0 1 1.954-.778l5.676 1a1 1 0 0 0 1.159-.81l.694-3.94a1 1 0 0 0-.81-1.158l-.493-.087a5.151 5.151 0 0 1-2.584-1.273l-2.935-2.687a4 4 0 0 0-1.816-.95c-4.418-1.002-8.23-1.314-11.435-.938-3.246.381-7.138 2.738-11.678 7.07a.3.3 0 0 0 .29.506c4.268-1.208 8.48-1.29 12.635-.248.8.14 1.064 1.415.795 3.822a2 2 0 0 0 1.64 2.192z"
        />
        <path
          fill="#000"
          fillOpacity=".2"
          d="M145.036 50.05l3.763.664a2 2 0 0 0 1.954-.779l1.191-1.606a2 2 0 0 1 1.954-.778l5.676 1a1 1 0 0 0 1.159-.81l.183-1.036a1 1 0 0 0-.761-1.149c-4.516-1.037-7.162-1.487-7.938-1.348-.79.142-1.933 1.185-3.43 3.13a.6.6 0 0 1-.58.225l-1.145-.202a.6.6 0 0 1-.494-.552l-.215-3.297a2 2 0 0 0-1.445-1.793c-2.033-.582-4.184-.792-6.454-.631-2.503.178-5.152.928-7.948 2.252l.113.239a.036.036 0 0 1 .009-.003c3.828-.736 7.82-.582 11.973.46.8.14 1.064 1.415.795 3.822a2 2 0 0 0 1.64 2.192z"
        />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M145.036 50.05l3.763.664a2 2 0 0 0 1.954-.779l1.191-1.606a2 2 0 0 1 1.954-.778l5.676 1a1 1 0 0 0 1.159-.81l.694-3.94a1 1 0 0 0-.81-1.158l-.493-.087a5.151 5.151 0 0 1-2.584-1.273l-2.935-2.687a4 4 0 0 0-1.816-.95c-4.418-1.002-8.23-1.314-11.435-.938-3.246.381-7.138 2.738-11.678 7.07a.3.3 0 0 0 .29.506c4.268-1.208 8.48-1.29 12.635-.248.8.14 1.064 1.415.795 3.822a2 2 0 0 0 1.64 2.192z"
        />
        <g transform="rotate(10 -125.038 764.082)">
          <use fill="#FF854B" xlinkHref="#f" />
          <path
            stroke="#24283D"
            strokeWidth="2"
            d="M15.982 14c-.145 7.839-.306 16.345-.482 25.52-.167 8.676-.594 18.125-1.28 28.346A2 2 0 0 0 16.214 70h4.59a2 2 0 0 0 1.996-2.124c-.73-11.75-1.163-21.202-1.3-28.357-.145-7.516-.306-16.022-.483-25.519h-5.036z"
          />
        </g>
        <path
          fill="#000"
          fillOpacity=".15"
          d="M146.726 49.597l2.954.521c-1.537 9.775-2.906 18.503-4.109 26.185-1.104 7.054-2.317 16.424-3.638 28.11a3 3 0 0 1-3.502 2.617l-.792-.14c1.312-11.277 2.778-21.511 4.398-30.703l4.689-26.59z"
        />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M144.09 49.883c-1.504 7.695-3.14 16.044-4.906 25.048-1.671 8.516-3.732 17.747-6.184 27.694a2 2 0 0 0 1.595 2.448l4.52.797a2 2 0 0 0 2.334-1.745c1.323-11.699 2.537-21.082 3.644-28.152a40884.63 40884.63 0 0 1 3.957-25.215l-4.96-.875z"
        />
        <g transform="rotate(10 -125.038 764.082)">
          <use fill="#CCC" xlinkHref="#g" />
          <rect
            width="4"
            height="10"
            x="32"
            y="2"
            stroke="#24283D"
            strokeWidth="2"
            rx="2"
          />
        </g>
      </g>
      <g>
        <g transform="translate(60 69)">
          <use fill="#FFF" xlinkHref="#h" />
          <path
            stroke="#24283D"
            strokeWidth="2"
            d="M5 2v12.586l1.144 1.144L5 19.162v12.602l1.217 2.433L5 35.414V42a4 4 0 0 0 4 4h108a2 2 0 0 0 2-2V15.414l-1.217-1.217L119 11.764V2H5z"
          />
        </g>
        <g transform="translate(60 69)">
          <use fill="#FFF" xlinkHref="#i" />
          <path
            stroke="#24283D"
            strokeWidth="2"
            d="M3 1a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h118a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3z"
          />
        </g>
        <path fill="#E5E5E5" d="M66 78h112v2H66z" />
      </g>
      <g transform="scale(1 -1) rotate(-14 -447.558 -183.094)">
        <use fill="#FF854B" xlinkHref="#j" />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M10.098 44.855l-.774-.757.817-.712c.543-.472.859-1.152.859-1.886V41a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v.5c0 .734.316 1.414.86 1.886l.816.712-.774.757A2.987 2.987 0 0 0 1 47v24a5 5 0 0 0 10 0V47c0-.819-.328-1.583-.902-2.145z"
        />
        <path
          fill="#000"
          fillOpacity=".15"
          d="M6.427 75.88L10 74l1-3V46l-2-2-1.143.057L8.5 47v21.15a14 14 0 0 1-1.114 5.473l-.959 2.257z"
        />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M10.098 44.855l-.774-.757.817-.712c.543-.472.859-1.152.859-1.886V41a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v.5c0 .734.316 1.414.86 1.886l.816.712-.774.757A2.987 2.987 0 0 0 1 47v24a5 5 0 0 0 10 0V47c0-.819-.328-1.583-.902-2.145z"
        />
        <use fill="#DDD" xlinkHref="#k" />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M4 39h4V12l.02-.196.904-4.525a1 1 0 0 0-.019-.47L7.245 1h-2.49l-1.66 5.809a1 1 0 0 0-.02.47l.906 4.525L4 12v27z"
        />
        <path fill="#000" fillOpacity=".2" d="M6 1l3 6-1 5v27H6V12l.5-5L6 2z" />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M4 39h4V12l.02-.196.904-4.525a1 1 0 0 0-.019-.47L7.245 1h-2.49l-1.66 5.809a1 1 0 0 0-.02.47l.906 4.525L4 12v27z"
        />
        <rect width="2" height="25" x="5" y="47" fill="#24283D" rx="1" />
      </g>
      <g>
        <g transform="translate(163.8 87.4)">
          <circle cx="15.5" cy="14.5" r="5.5" fill="#FFF" />
          <path
            fill="#FF854B"
            d="M7.91 23.128a11.01 11.01 0 0 1-2.303-2.91l1.7-3.515-3.043-2.45c.072-1.216.346-2.437.84-3.615l3.808-.862.018-3.906a11.1 11.1 0 0 1 3.35-1.598l3.048 2.44 3.065-2.421a11.128 11.128 0 0 1 3.339 1.621l-.007 3.906 3.801.886a11.1 11.1 0 0 1 .817 3.621l-3.059 2.43 1.678 3.525a10.998 10.998 0 0 1-2.322 2.896l-3.807-.876-1.71 3.51a11.01 11.01 0 0 1-3.712-.01l-1.688-3.523-3.813.851zm5.71-4.786a3.838 3.838 0 1 0 3.352-6.905 3.838 3.838 0 0 0-3.352 6.905z"
          />
          <path
            stroke="#24283D"
            strokeWidth="2"
            d="M7.661 23.089a11.01 11.01 0 0 1-2.287-2.923l1.719-3.505-3.03-2.466c.077-1.215.358-2.435.859-3.611l3.812-.842.038-3.905a11.1 11.1 0 0 1 3.36-1.58l3.034 2.455 3.077-2.405a11.128 11.128 0 0 1 3.33 1.638l-.027 3.906 3.797.906a11.1 11.1 0 0 1 .797 3.626l-3.07 2.413 1.658 3.534a10.998 10.998 0 0 1-2.336 2.884l-3.803-.897-1.729 3.501a11.01 11.01 0 0 1-3.711-.029l-1.67-3.532-3.818.832zm5.735-4.757a3.838 3.838 0 1 0 3.39-6.887 3.838 3.838 0 0 0-3.39 6.887z"
          />
        </g>
        <path
          fill="#BBB"
          stroke="#24283D"
          strokeWidth="2"
          d="M188.623 111.673a6.84 6.84 0 0 1-1.252-2.3l1.417-2.192-1.309-2.26a6.883 6.883 0 0 1 1.364-2.235l2.609.13 1.302-2.261a6.84 6.84 0 0 1 2.617.062l1.192 2.325 2.612-.003a6.84 6.84 0 0 1 1.252 2.3l-1.417 2.192 1.309 2.26a6.883 6.883 0 0 1-1.364 2.234l-2.609-.13-1.302 2.262a6.84 6.84 0 0 1-2.617-.062l-1.192-2.325-2.612.003zm4.355-2.873a1.763 1.763 0 1 0 1.837-3.01 1.763 1.763 0 0 0-1.837 3.01z"
        />
      </g>
      <g fill="#EEE">
        <path d="M205.096 15H144.53a1.527 1.527 0 0 1-.884-2.772l2.358-1.675a10.08 10.08 0 0 1 3.382-1.558l7.04-1.768a10.08 10.08 0 0 0 4.235-2.236l2.762-2.451a10.08 10.08 0 0 1 6.69-2.54h4.056a7.39 7.39 0 0 1 5.179 2.117 7.39 7.39 0 0 0 5.178 2.118h2.171a10.08 10.08 0 0 1 7.063 2.887l1.935 1.9a8.527 8.527 0 0 0 4.931 2.38l.199.024c1.749.216 3.41.889 4.816 1.952a.902.902 0 0 1-.545 1.622zM26.028 22h66.235a1.74 1.74 0 0 0 1.03-3.141l-2.576-1.893a10.976 10.976 0 0 0-3.74-1.779l-7.653-1.988a10.976 10.976 0 0 1-4.663-2.539l-3.016-2.77A10.976 10.976 0 0 0 64.222 5h-4.303a8.037 8.037 0 0 0-5.728 2.4 8.037 8.037 0 0 1-5.728 2.4h-2.238c-2.942 0-5.76 1.18-7.823 3.276l-2.153 2.188a9.15 9.15 0 0 1-5.363 2.658l-.182.023a10.844 10.844 0 0 0-5.31 2.216A1.029 1.029 0 0 0 26.028 22z" />
      </g>
    </g>
  </svg>
);

const BrokenFile = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 174 88"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <path
        d="M57,88 L57.7764911,32.9435914 L57.7764911,32.9435914 C57.8073345,30.7566675 59.588952,29 61.7760934,29 L77.3865366,29 L77.3865366,29 C78.9621284,29 80.4460467,29.7407552 81.3930377,31 L82.2970365,32.2020766 L82.2970365,32.2020766 C82.6748496,32.7044671 83.2668762,33 83.8954769,33 L116.069552,33 L116.069552,33 C118.250269,33 120.029137,34.7467333 120.068887,36.9270879 L121,88 L57,88 Z"
        id="path-1"
      />
      <path
        d="M55.5095142,38 L87.8350688,38 L87.8350688,38 C88.3873535,38 88.8350688,38.4477153 88.8350688,39 C88.8350688,39.1638297 88.7948174,39.3251503 88.717854,39.4697768 L83.5115471,49.2532557 L83.5115471,49.2532557 C83.4903444,49.2930989 83.4984585,49.3422064 83.5313509,49.3731115 L88.671037,54.2022554 L88.671037,54.2022554 C89.0735314,54.5804309 89.0932457,55.2132888 88.7150702,55.6157832 C88.6857419,55.6469975 88.6544386,55.6762953 88.6213535,55.7034956 L81.5503208,61.5168186 L81.5503208,61.5168186 C81.507659,61.5518922 81.5015076,61.6149091 81.5365812,61.6575709 C81.5380545,61.659363 81.5395897,61.6611032 81.5411841,61.6627885 L88.7631898,69.2966435 L88.7631898,69.2966435 C89.1427418,69.6978401 89.1251953,70.3307619 88.7239986,70.7103139 C88.7071459,70.7262574 88.6897434,70.7416096 88.6718229,70.7563427 L81.5394509,76.6200946 L81.5394509,76.6200946 C81.4989154,76.6534202 81.4910349,76.7124103 81.5214012,76.7552077 L88.3798742,86.421329 L88.3798742,86.421329 C88.6994653,86.871751 88.593406,87.49597 88.142984,87.8155611 C87.9738799,87.9355468 87.7716601,88 87.5643131,88 L57.1963386,88 L57.1963386,88 C55.0496461,88 53.2857078,86.3054838 53.1995607,84.1605205 L51.5127364,42.1605205 L51.5127364,42.1605205 C51.4240833,39.9531611 53.1416342,38.0918752 55.3489937,38.0032222 C55.4024736,38.0010743 55.4559912,38 55.5095142,38 Z"
        id="path-2"
      />
      <path
        d="M88.0094277,38 L118.250126,38 L118.250126,38 C119.014714,38 119.712397,38.4359156 120.047633,39.1230913 L124.677265,48.6130128 L124.677265,48.6130128 C124.869098,49.0062357 124.783031,49.4785085 124.464817,49.7787809 L119.082113,54.857988 L119.082113,54.857988 C119.041944,54.8958916 119.040108,54.9591815 119.078012,54.9993499 C119.080854,55.0023621 119.083881,55.0051947 119.087074,55.0078316 L126.176503,60.8613192 L126.176503,60.8613192 C126.602382,61.2129521 126.66257,61.8432498 126.310937,62.2691286 C126.297067,62.285927 126.282652,62.3022676 126.267715,62.3181244 L119.072938,69.9558712 L119.072938,69.9558712 C119.035069,69.996072 119.036959,70.0593603 119.07716,70.0972295 C119.078746,70.0987233 119.08038,70.1001648 119.08206,70.1015517 L126.285591,76.0492502 L126.285591,76.0492502 C126.688556,76.3819639 126.7674,76.9688433 126.466536,77.3961131 L118.999736,88 L89.6896707,88 L89.6896707,88 C87.5427358,88 85.7786889,86.3051141 85.6928678,84.1598952 L84.0126247,42.1598952 L84.0126247,42.1598952 C83.924317,39.9525219 85.6421591,38.0915048 87.8495324,38.0031971 C87.9028042,38.0010659 87.9561133,38 88.0094277,38 Z"
        id="path-3"
      />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Something-is-broken"
        transform="translate(-413.000000, -261.000000)"
      >
        <g id="Group-2" transform="translate(325.000000, 261.000000)">
          <g id="Broken-File" transform="translate(88.000000, 0.000000)">
            <path
              d="M145.291859,86.9064564 C147.788142,80.2721016 149.153709,73.0839507 149.153709,65.5768546 C149.153709,32.1211816 122.032528,5 88.5768546,5 C55.1211816,5 28,32.1211816 28,65.5768546 C28,73.1725212 29.3979797,80.4416722 31.9506773,87.1410458 C33.8661268,86.9064564 143.524395,87.1410458 145.291859,86.9064564 Z"
              id="Oval-9"
              fill="#F7F7F7"
            />
            <g id="Rectangle-29">
              <use fill="#FF854B" fillRule="evenodd" xlinkHref="#path-1" />
              <path
                stroke="#24283D"
                strokeWidth="2"
                d="M58.014203,87 L119.981603,87 L119.069053,36.9453159 C119.039241,35.31005 117.705089,34 116.069552,34 L83.8954769,34 C82.9525758,34 82.064536,33.5567006 81.4978163,32.8031149 L80.5938175,31.6010383 C79.835733,30.5929887 78.647828,30 77.3865366,30 L61.7760934,30 C60.1357374,30 58.7995243,31.3175006 58.7763917,32.9576935 L58.014203,87 Z"
              />
            </g>
            <g id="Rectangle-32">
              <use fill="#FFFFFF" fillRule="evenodd" xlinkHref="#path-2" />
              <path
                stroke="#24283D"
                strokeWidth="2"
                d="M55.5095142,39 C55.469372,39 55.4292337,39.0008057 55.3891238,39.0024166 C53.7336042,39.0689064 52.4454411,40.4648708 52.5119308,42.1203904 L54.1987552,84.1203904 C54.2633655,85.7291128 55.5863192,87 57.1963386,87 L87.5643131,87 L80.7058401,77.3338787 C80.3718106,76.8631077 80.4584958,76.2142165 80.9043871,75.847635 L88.036759,69.9838831 L80.8147533,62.3500281 C80.7887717,62.3219187 80.7887717,62.3219187 80.7641216,62.2926348 C80.3783119,61.8233553 80.4459775,61.1301686 80.9152569,60.7443589 L87.9862896,54.9310359 L82.8466036,50.101892 C82.4847871,49.7619367 82.3955326,49.2217539 82.6287618,48.783479 L87.8350688,39 L55.5095142,39 Z"
              />
            </g>
            <path
              d="M86,85.5 L54.5,85.5"
              id="Path-34"
              stroke="#EEEEEE"
              strokeWidth="2"
            />
            <path
              d="M55.5095142,39 C55.469372,39 55.4292337,39.0008057 55.3891238,39.0024166 C53.7336042,39.0689064 52.4454411,40.4648708 52.5119308,42.1203904 L54.1987552,84.1203904 C54.2633655,85.7291128 55.5863192,87 57.1963386,87 L87.5643131,87 L80.7058401,77.3338787 C80.3718106,76.8631077 80.4584958,76.2142165 80.9043871,75.847635 L88.036759,69.9838831 L80.8147533,62.3500281 C80.7887717,62.3219187 80.7887717,62.3219187 80.7641216,62.2926348 C80.3783119,61.8233553 80.4459775,61.1301686 80.9152569,60.7443589 L87.9862896,54.9310359 L82.8466036,50.101892 C82.4847871,49.7619367 82.3955326,49.2217539 82.6287618,48.783479 L87.8350688,39 L55.5095142,39 Z"
              id="Rectangle-32"
              stroke="#24283D"
              strokeWidth="2"
            />
            <g
              id="Rectangle-32"
              transform="translate(105.499868, 63.000000) scale(-1, 1) translate(-105.499868, -63.000000) "
            >
              <use fill="#FFFFFF" fillRule="evenodd" xlinkHref="#path-3" />
              <path
                stroke="#24283D"
                strokeWidth="2"
                d="M118.480849,87 L125.648903,76.820372 L118.445372,70.8726735 C118.417906,70.8494885 118.417906,70.8494885 118.391477,70.8251294 C117.949268,70.4085676 117.928477,69.7123965 118.345039,69.2701877 L125.539815,61.6324409 L118.450387,55.7789534 C118.39861,55.7343685 118.39861,55.7343685 118.350698,55.685655 C117.933759,55.2438023 117.953955,54.5476137 118.395808,54.1306743 L123.778511,49.0514672 L119.14888,39.5615456 C118.981261,39.2179578 118.63242,39 118.250126,39 L88.0094277,39 C87.9694419,39 87.9294601,39.0007994 87.8895062,39.0023978 C86.2339762,39.0686286 84.9455947,40.4643915 85.0118255,42.1199214 L86.6920685,84.1199214 C86.7564344,85.7288356 88.0794695,87 89.6896707,87 L118.480849,87 Z"
              />
            </g>
            <path
              d="M124.5,40 L122.584052,83.5878273 L122.584052,83.5878273 C122.537046,84.6572085 121.656395,85.5 120.585981,85.5 L91.5,85.5"
              id="Path-33"
              stroke="#EEEEEE"
              strokeWidth="2"
            />
            <path
              d="M118.822272,87 L125.990327,76.820372 L118.786795,70.8726735 C118.75933,70.8494885 118.75933,70.8494885 118.7329,70.8251294 C118.290691,70.4085676 118.2699,69.7123965 118.686462,69.2701877 L125.881238,61.6324409 L118.79181,55.7789534 C118.740034,55.7343685 118.740034,55.7343685 118.692121,55.685655 C118.275182,55.2438023 118.295378,54.5476137 118.737231,54.1306743 L124.119935,49.0514672 L119.490303,39.5615456 C119.322685,39.2179578 118.973843,39 118.59155,39 L88.3508509,39 C88.3108651,39 88.2708833,39.0007994 88.2309295,39.0023978 C86.5753995,39.0686286 85.2870179,40.4643915 85.3532487,42.1199214 L87.0334918,84.1199214 C87.0978576,85.7288356 88.4208928,87 90.0310939,87 L118.822272,87 Z"
              id="Rectangle-32"
              stroke="#24283D"
              strokeWidth="2"
              transform="translate(105.670580, 63.000000) scale(-1, 1) translate(-105.670580, -63.000000) "
            />
            <path
              d="M110.903754,15 L171.470396,15 L171.470396,15 C172.313681,15 172.997298,14.3163825 172.997298,13.4730975 C172.997298,12.9784995 172.757728,12.5145387 172.354467,12.2281681 L169.995636,10.5530733 L169.995636,10.5530733 C168.974969,9.82825854 167.828217,9.29990793 166.614058,8.99505515 L159.574081,7.22744866 L159.574081,7.22744866 C158.003159,6.83301963 156.550417,6.06584628 155.338871,4.9908923 L152.576564,2.54001238 L152.576564,2.54001238 C150.732282,0.903658368 148.352215,1.73694721e-15 145.886647,0 L141.830601,-1.56184302e-15 L141.830601,8.8817842e-16 C139.893807,1.24396184e-15 138.034408,0.760290676 136.652476,2.11728674 L136.652476,2.11728674 L136.652476,2.11728674 C135.270544,3.4742828 133.411146,4.23457347 131.474351,4.23457347 L129.302702,4.23457347 L129.302702,4.23457347 C126.661105,4.23457347 124.125068,5.271535 122.240249,7.12234384 L120.304784,9.02288565 L120.304784,9.02288565 C118.967287,10.3362487 117.234276,11.1722763 115.373842,11.4016378 L115.175019,11.4261495 L115.175019,11.4261495 C113.426128,11.6417595 111.765061,12.3149056 110.35947,13.377647 L110.35947,13.377647 L110.35947,13.377647 C109.961894,13.6782469 109.883279,14.2442305 110.183879,14.6418066 C110.354453,14.8674098 110.620925,15 110.903754,15 Z"
              id="Path-19"
              fill="#EEEEEE"
              transform="translate(141.500000, 7.500000) scale(-1, 1) translate(-141.500000, -7.500000) "
            />
            <path
              d="M1.02605182,19 L68.2645403,19 L68.2645403,19 C69.2231495,19 70.0002558,18.2228937 70.0002558,17.2642844 C70.0002558,16.7077902 69.733426,16.1850397 69.2827413,15.8585905 L66.6722051,13.9676734 L66.6722051,13.9676734 C65.5315189,13.1414281 64.2452196,12.5377558 62.8807646,12.1883149 L55.1086114,10.1978439 L55.1086114,10.1978439 C53.3464278,9.74654355 51.7206867,8.87281713 50.371954,7.65220942 L47.3262065,4.89579732 L47.3262065,4.89579732 C45.2668256,3.03205047 42.5883915,2 39.8108743,2 L35.4004669,2 L35.4004669,2 C33.2295386,2 31.1477167,2.86329079 29.6138624,4.39959163 L29.6138624,4.39959163 L29.6138624,4.39959163 C28.080008,5.93589248 25.9981861,6.79918327 23.8272579,6.79918327 L21.5122924,6.79918327 L21.5122924,6.79918327 C18.538775,6.79918327 15.6873064,7.98163147 13.5863882,10.0859006 L11.428056,12.2476754 L11.428056,12.2476754 C9.9569874,13.7210903 8.03673134,14.6620833 5.97093557,14.9218562 L5.77083419,14.9470189 L5.77083419,14.9470189 C3.81494747,15.1929708 1.96041404,15.9574833 0.399411055,17.1613333 L0.399411055,17.1613333 L0.399411055,17.1613333 C-0.0493478103,17.5074175 -0.132582122,18.151765 0.213502017,18.6005239 C0.407782002,18.852442 0.707920636,19 1.02605182,19 Z"
              id="Path-19"
              fill="#EEEEEE"
            />
            <path
              d="M15,86 L163,86 C163.552285,86 164,86.4477153 164,87 L164,87 C164,87.5522847 163.552285,88 163,88 L15,88 C14.4477153,88 14,87.5522847 14,87 L14,87 L14,87 C14,86.4477153 14.4477153,86 15,86 Z M167,86 L169,86 C169.552285,86 170,86.4477153 170,87 L170,87 C170,87.5522847 169.552285,88 169,88 L167,88 C166.447715,88 166,87.5522847 166,87 L166,87 L166,87 C166,86.4477153 166.447715,86 167,86 Z M173,86 C173.552285,86 174,86.4477153 174,87 L174,87 C174,87.5522847 173.552285,88 173,88 C172.447715,88 172,87.5522847 172,87 L172,87 L172,87 C172,86.4477153 172.447715,86 173,86 Z M9,86 L11,86 C11.5522847,86 12,86.4477153 12,87 L12,87 C12,87.5522847 11.5522847,88 11,88 L9,88 C8.44771525,88 8,87.5522847 8,87 L8,87 L8,87 C8,86.4477153 8.44771525,86 9,86 Z M5,86 L5,86 C5.55228475,86 6,86.4477153 6,87 L6,87 C6,87.5522847 5.55228475,88 5,88 C4.44771525,88 4,87.5522847 4,87 L4,87 L4,87 C4,86.4477153 4.44771525,86 5,86 L5,86 Z"
              id="Combined-Shape"
              fill="#24283D"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const SharedFile = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 408 226"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <path
        d="M15.6000009,1.65374559e-15 L78.2368741,0 C83.8742099,-1.03556179e-15 89.2701112,2.28818646 93.188983,6.34059291 L120.352934,34.430149 C123.166196,37.3392713 124.738854,41.2278012 124.738854,45.2747052 L124.738854,148.055172 C124.738854,156.670814 117.754495,163.655172 109.138853,163.655172 L15.6000009,163.655172 C6.98435829,163.655172 -7.2124493e-16,156.670814 -1.77635684e-15,148.055172 L-1.77635684e-15,15.6000009 C-2.83146875e-15,6.98435829 6.98435829,8.68809522e-15 15.6000009,7.10542736e-15 Z"
        id="path-1"
      />
      <rect
        id="path-2"
        x="0"
        y="0"
        width="57.1719745"
        height="25.9770115"
        rx="7.80000043"
      />
    </defs>
    <g
      id="Shared-Files---Public-Landing-Page"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Shared-Files---Selected-File-Placeholder"
        transform="translate(-1562.000000, -654.000000)"
      >
        <g id="Group-2" transform="translate(1561.000000, 653.000000)">
          <g id="Broken-File">
            <path
              d="M322.920287,226.502936 C328.167681,212.445619 331.038217,197.214881 331.038217,181.30834 C331.038217,110.420208 274.02724,52.954023 203.700637,52.954023 C133.374034,52.954023 76.3630573,110.420208 76.3630573,181.30834 C76.3630573,197.40255 79.3017267,212.804916 84.6677091,227 C88.6941431,226.502936 319.20493,227 322.920287,226.502936 Z"
              id="Oval-9"
              fill="#F7F7F7"
            />
            <path
              d="M406.652393,47.7586207 L249.253632,47.7586207 C247.06316,47.7586207 245.287432,45.9828921 245.287432,43.7924198 C245.287432,42.5074177 245.909979,41.3020466 246.957818,40.5582298 L253.086304,36.2078768 C255.739722,34.3243273 258.720704,32.951384 261.876798,32.1592604 L280.168734,27.5683091 C284.252343,26.5433956 288.028922,24.5497335 291.178808,21.7560737 L298.352428,15.39373 C303.14707,11.1413219 309.333663,8.79310345 315.742373,8.79310345 L326.282505,8.79310345 C331.314835,8.79310345 336.146177,10.7680376 339.737514,14.2931816 C343.328852,17.8183257 348.160194,19.7932598 353.192524,19.7932598 L358.83533,19.7932598 C365.701693,19.7932598 372.293818,22.487959 377.194019,27.2978423 L382.219683,32.2308763 C385.696169,35.6432857 390.200036,37.8153307 395.034856,38.4111511 L395.552497,38.4749426 C400.096804,39.0349616 404.413053,40.7835213 408.065836,43.5442326 C409.098703,44.3248556 409.303186,45.7949793 408.522563,46.8278457 C408.079507,47.4140669 407.387209,47.7586207 406.652393,47.7586207 Z M3.50473584,42.5632184 C2.72181708,42.5632184 1.98404739,42.1966938 1.51109221,41.5727746 C0.676446416,40.4717156 0.892416969,38.9025169 1.99347594,38.0678711 C5.87789668,35.1233281 10.4714835,33.2576106 15.3089968,32.6596787 L15.8518194,32.5925842 C20.9931077,31.9571048 25.7809584,29.6426365 29.4725644,26.0082555 L34.7931965,20.7701004 C40.0243382,15.6200485 47.070796,12.7335001 54.4116323,12.7335001 L60.3385679,12.7335001 C65.6974076,12.7335001 70.8413497,10.6263084 74.6601039,6.86675007 C78.4788581,3.10719177 83.6228002,1 88.9816398,1 L100.120171,1 C106.972524,1 113.586366,3.515988 118.706182,8.0703508 L126.283221,14.8105498 C129.645211,17.8012278 133.679251,19.936441 138.042799,21.0348835 L157.438641,25.9174269 C160.812005,26.7666089 163.997317,28.23774 166.831067,30.2553034 L173.330575,34.8828015 C174.445941,35.6769161 175.108265,36.9615207 175.108265,38.3307027 C175.108265,40.6682566 173.213303,42.5632184 170.87575,42.5632184 L3.50473584,42.5632184 Z"
              id="Combined-Shape"
              fill="#EEEEEE"
            />
            <path
              d="M50.3747712,221.804598 L357.026503,221.804598 C358.461173,221.804598 359.624204,222.967628 359.624204,224.402299 C359.624204,225.83697 358.461173,227 357.026503,227 L50.3747712,227 C48.9401005,227 47.7770701,225.83697 47.7770701,224.402299 C47.7770701,222.967628 48.9401005,221.804598 50.3747712,221.804598 Z M367.419357,221.804598 L372.618859,221.804598 C374.05353,221.804598 375.216561,222.967628 375.216561,224.402299 C375.216561,225.83697 374.05353,227 372.618859,227 L367.419357,227 C365.984686,227 364.821656,225.83697 364.821656,224.402299 C364.821656,222.967628 365.984686,221.804598 367.419357,221.804598 Z M383.011714,221.804598 L383.013764,221.804598 C384.448435,221.804598 385.611465,222.967628 385.611465,224.402299 C385.611465,225.83697 384.448435,227 383.013764,227 L383.011714,227 C381.577043,227 380.414013,225.83697 380.414013,224.402299 C380.414013,222.967628 381.577043,221.804598 383.011714,221.804598 Z M34.7824145,221.804598 L39.9819167,221.804598 C41.4165874,221.804598 42.5796178,222.967628 42.5796178,224.402299 C42.5796178,225.83697 41.4165874,227 39.9819167,227 L34.7824145,227 C33.3477438,227 32.1847134,225.83697 32.1847134,224.402299 C32.1847134,222.967628 33.3477438,221.804598 34.7824145,221.804598 Z M24.3875101,221.804598 L24.38956,221.804598 C25.8242307,221.804598 26.9872611,222.967628 26.9872611,224.402299 C26.9872611,225.83697 25.8242307,227 24.38956,227 L24.3875101,227 C22.9528393,227 21.7898089,225.83697 21.7898089,224.402299 C21.7898089,222.967628 22.9528393,221.804598 24.3875101,221.804598 Z"
              id="Combined-Shape"
              fill="#24283D"
            />
          </g>
          <g id="Group-4" transform="translate(136.133758, 63.344828)">
            <g id="Group-16">
              <g id="Group-8" transform="translate(10.394904, 0.000000)">
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fillRule="evenodd" />
                  <path
                    stroke="#24283D"
                    fill="#FFFFFF"
                    strokeWidth="5.20000029"
                    d="M15.6000009,2.60000014 C8.42029872,2.60000014 2.60000014,8.42029872 2.60000014,15.6000009 L2.60000014,148.055172 C2.60000014,155.234874 8.42029872,161.055172 15.6000009,161.055172 L109.138853,161.055172 C116.318555,161.055172 122.138853,155.234874 122.138853,148.055172 L122.138853,45.2747052 C122.138853,41.9022852 120.828305,38.6618436 118.483921,36.237575 L91.3199694,8.14801894 C87.8909565,4.60216329 83.169543,2.60000014 78.2368741,2.60000014 L15.6000009,2.60000014 Z"
                  />
                </g>
                <path
                  d="M80.5605096,5.1954023 L80.5605096,31.1609188 C80.5605096,38.340621 86.3808081,44.1609195 93.5605103,44.1609195 L119.541401,44.1609195"
                  id="Path-15"
                  stroke="#E5E5E5"
                  strokeWidth="5.20000029"
                />
                <path
                  d="M116.942675,44.1609195 L116.942675,148.062069 C116.942675,152.36989 113.450496,155.862069 109.142675,155.862069 L5.19745223,155.862069"
                  id="Path-16"
                  stroke="#E5E5E5"
                  strokeWidth="5.20000029"
                />
                <path
                  d="M15.6000009,2.60000014 C8.42029872,2.60000014 2.60000014,8.42029872 2.60000014,15.6000009 L2.60000014,148.055172 C2.60000014,155.234874 8.42029872,161.055172 15.6000009,161.055172 L109.138853,161.055172 C116.318555,161.055172 122.138853,155.234874 122.138853,148.055172 L122.138853,45.2747052 C122.138853,41.9022852 120.828305,38.6618436 118.483921,36.237575 L91.3199694,8.14801894 C87.8909565,4.60216329 83.169543,2.60000014 78.2368741,2.60000014 L15.6000009,2.60000014 Z"
                  id="Rectangle-14"
                  stroke="#24283D"
                  strokeWidth="5.20000029"
                />
                <path
                  d="M67.566879,2.59770115 L77.9579614,2.59770115 C82.2657826,2.59770115 85.7579618,6.08988029 85.7579618,10.3977016 L85.7579618,31.1655168 C85.7579618,35.4733381 89.2501409,38.9655172 93.5579622,38.9655172 L114.340127,38.9655172 C118.647948,38.9655172 122.140127,42.4576964 122.140127,46.7655177 L122.140127,62.3448276"
                  id="Path-2"
                  stroke="#24283D"
                  strokeWidth="5.20000029"
                />
              </g>
              <g id="Group-15" transform="translate(0.000000, 101.310345)">
                <g id="Rectangle-15">
                  <use fill="#FF864E" fillRule="evenodd" />
                  <rect
                    stroke="#24283D"
                    fill="#ff864e"
                    strokeWidth="5.20000029"
                    x="2.60000014"
                    y="2.60000014"
                    width="51.9719742"
                    height="20.7770112"
                    rx="7.80000043"
                  />
                </g>
                <rect
                  id="Rectangle-15"
                  stroke="#24283D"
                  strokeWidth="5.20000029"
                  x="2.60000014"
                  y="2.60000014"
                  width="51.9719742"
                  height="20.7770112"
                  rx="7.80000043"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const StoryEmpty = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 200 120"
    preserveAspectRatio="xMidYMid meet"
  >
    <g fill="none" fillRule="evenodd" transform="translate(21 24)">
      <path
        fill="#EEEEEE"
        d="M157.1 17H96.53a1.53 1.53 0 0 1-.88-2.77L98 12.55a10.08 10.08 0 0 1 3.4-1.55l7.04-1.77c1.57-.4 3.02-1.16 4.23-2.24l2.76-2.45a10.08 10.08 0 0 1 6.7-2.54h4.05c1.94 0 3.8.76 5.18 2.12a7.4 7.4 0 0 0 5.18 2.11h2.17c2.64 0 5.17 1.04 7.06 2.9l1.94 1.9a8.53 8.53 0 0 0 4.93 2.37l.2.03c1.74.21 3.4.88 4.81 1.95a.9.9 0 0 1-.54 1.62zM.96 16h64.4a1.63 1.63 0 0 0 .95-2.96l-2.5-1.78A10.76 10.76 0 0 0 60.2 9.6l-7.47-1.88a10.76 10.76 0 0 1-4.52-2.4l-2.92-2.59A10.76 10.76 0 0 0 38.14 0h-4.28c-2.07 0-4.05.81-5.52 2.26a7.85 7.85 0 0 1-5.5 2.26h-2.29a10.7 10.7 0 0 0-7.54 3.09l-2.05 2.02a9.05 9.05 0 0 1-5.24 2.53l-.21.03c-1.87.23-3.63.95-5.13 2.08A.96.96 0 0 0 .96 16z"
      />
      <path
        fill="#F5F5F5"
        d="M117.93 91.75A46.66 46.66 0 0 0 124 68.6C124 42.86 103.4 22 78 22S32 42.86 32 68.6A47.07 47.07 0 0 0 38.21 92c8.32-.1 70.05 0 79.72-.25z"
      />
      <g fill="#24283D" transform="translate(13 90)">
        <rect width="110" height="2" x="10" rx="1" />
        <rect width="4" height="2" x="122" rx="1" />
        <rect width="2" height="2" x="128" rx="1" />
        <rect width="4" height="2" x="4" rx="1" />
        <rect width="2" height="2" rx="1" />
      </g>
      <g transform="translate(45 28)">
        <path
          fill="#FFFFFF"
          stroke="#24283D"
          strokeWidth="2"
          d="M10.26 1c-3.1 0-4.38.25-5.7.95a6.27 6.27 0 0 0-2.61 2.61c-.7 1.32-.95 2.6-.95 5.7v43.48c0 3.1.25 4.38.95 5.7a6.27 6.27 0 0 0 2.61 2.61c1.32.7 2.6.95 5.7.95h45.48c3.1 0 4.38-.25 5.7-.95a6.27 6.27 0 0 0 2.61-2.61c.7-1.32.95-2.6.95-5.7V10.26c0-3.1-.25-4.38-.95-5.7a6.27 6.27 0 0 0-2.61-2.61c-1.32-.7-2.6-.95-5.7-.95H10.26z"
        />
        <path stroke="#E5E5E5" strokeWidth="2" d="M63 3v53a5 5 0 0 1-5 5H3" />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M10.26 1c-3.1 0-4.38.25-5.7.95a6.27 6.27 0 0 0-2.61 2.61c-.7 1.32-.95 2.6-.95 5.7v43.48c0 3.1.25 4.38.95 5.7a6.27 6.27 0 0 0 2.61 2.61c1.32.7 2.6.95 5.7.95h45.48c3.1 0 4.38-.25 5.7-.95a6.27 6.27 0 0 0 2.61-2.61c.7-1.32.95-2.6.95-5.7V10.26c0-3.1-.25-4.38-.95-5.7a6.27 6.27 0 0 0-2.61-2.61c-1.32-.7-2.6-.95-5.7-.95H10.26z"
        />
        <rect width="14" height="2" x="42" y="12" fill="#24283D" rx="1" />
        <rect width="14" height="2" x="42" y="22" fill="#24283D" rx="1" />
        <rect width="14" height="2" x="42" y="32" fill="#24283D" rx="1" />
        <rect width="46" height="2" x="10" y="42" fill="#24283D" rx="1" />
        <rect width="46" height="2" x="10" y="52" fill="#24283D" rx="1" />
        <g strokeWidth="2" transform="translate(10 10)">
          <path
            fill="#FFFFFF"
            stroke="#24283D"
            d="M5.13 1c-1.48 0-2.04.1-2.61.42-.48.25-.85.62-1.1 1.1C1.1 3.09 1 3.65 1 5.12v15.75c0 1.48.1 2.04.42 2.61.25.48.62.85 1.1 1.1.57.31 1.13.42 2.6.42h15.75c1.48 0 2.04-.1 2.61-.42.48-.25.85-.62 1.1-1.1.31-.57.42-1.13.42-2.6V5.12c0-1.48-.1-2.04-.42-2.61a2.63 2.63 0 0 0-1.1-1.1c-.57-.31-1.13-.42-2.6-.42H5.12z"
          />
          <path
            stroke="#E5E5E5"
            d="M1 18.06l4.51-3.63a2 2 0 0 1 2.76.23l3.7 4.18L13 20"
          />
          <path
            stroke="#24283D"
            d="M1 16.1l4.5-3.66a2 2 0 0 1 2.77.23l3.48 3.97a2 2 0 0 0 2.74.26l2.13-1.67a2 2 0 0 1 2.63.15L25 21"
          />
          <path
            stroke="#E5E5E5"
            d="M7 25l5.8-4.8 3.74-2.83a2 2 0 0 1 2.58.14L25 23.08"
          />
          <path
            stroke="#24283D"
            d="M5.5 24.8l7.8-6.65 3.5-2.72a2 2 0 0 1 2.62.14L25 21"
          />
          <circle cx="15.5" cy="8.5" r="2.5" fill="#FF854B" stroke="#24283D" />
          <path
            stroke="#24283D"
            d="M5.13 1c-1.48 0-2.04.1-2.61.42-.48.25-.85.62-1.1 1.1C1.1 3.09 1 3.65 1 5.12v15.75c0 1.48.1 2.04.42 2.61.25.48.62.85 1.1 1.1.57.31 1.13.42 2.6.42h15.75c1.48 0 2.04-.1 2.61-.42.48-.25.85-.62 1.1-1.1.31-.57.42-1.13.42-2.6V5.12c0-1.48-.1-2.04-.42-2.61a2.63 2.63 0 0 0-1.1-1.1c-.57-.31-1.13-.42-2.6-.42H5.12z"
          />
        </g>
      </g>
      <g transform="translate(100 72)">
        <circle
          cx="10"
          cy="10"
          r="9"
          fill="#FF854B"
          stroke="#24283D"
          strokeWidth="2"
        />
        <path
          fill="#000000"
          fillOpacity=".2"
          d="M10 20c5.52 0 10-4.56 10-10.27 0-3.42-2.22 6.28-10 6.28C2.22 16 0 6.3 0 9.73 0 15.4 4.48 20 10 20z"
        />
        <circle cx="10" cy="10" r="9" stroke="#24283D" strokeWidth="2" />
        <g fill="#24283D" transform="translate(6 6)">
          <path d="M4.06-.38c.61 0 1.1.5 1.1 1.1V7.4a1.1 1.1 0 0 1-2.21 0V.73c0-.62.5-1.11 1.1-1.11z" />
          <path d="M4.06-.38c-.62 0-1.11.5-1.11 1.1V7.4a1.11 1.11 0 0 0 2.22 0V.73c0-.62-.5-1.11-1.11-1.11z" />
        </g>
      </g>
    </g>
  </svg>
);

const file = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 137 165"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <path
        d="M15.6816004,1.65247849e-15 L78.8677255,2.13162821e-14 C84.5128489,2.52931666e-14 89.9181091,2.28262595 93.8545122,6.32887726 L121.214541,34.4524075 C124.062564,37.3799068 125.656051,41.3030521 125.656051,45.3873499 L125.656051,148.193417 C125.656051,156.854126 118.635159,163.875018 109.974451,163.875018 L15.6816004,163.875018 C7.02089163,163.875018 1.06063092e-15,156.854126 0,148.193417 L-3.55271368e-15,15.6816004 C-4.6133446e-15,7.02089163 7.02089163,-1.96176729e-15 15.6816004,-3.55271368e-15 Z"
        id="path-1"
      />
      <rect
        id="path-2"
        x="0"
        y="106.648821"
        width="57.5923567"
        height="26.0119076"
        rx="7.84080018"
      />
    </defs>
    <g
      id="Manage-Users"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Manage-Users---Bulk-Edit"
        transform="translate(-1295.000000, -853.000000)"
      >
        <g
          id="Pop-Up"
          fill="#fff"
          transform="translate(816.000000, 460.000000)"
        >
          <g id="Group-10" transform="translate(340.000000, 293.000000)">
            <g id="Group-9" transform="translate(139.000000, 100.000000)">
              <g id="Group-2">
                <g id="Group-16" transform="translate(0.127389, 0.226197)">
                  <g id="Group-8" transform="translate(10.471338, 0.000000)">
                    <g id="Rectangle-14">
                      <use fill="#FFFFFF" fillRule="evenodd" />
                      <path
                        stroke="#24283D"
                        strokeWidth="5.22720012"
                        d="M15.6816004,2.61360006 C8.46434309,2.61360006 2.61360006,8.46434309 2.61360006,15.6816004 L2.61360006,148.193417 C2.61360006,155.410675 8.46434309,161.261418 15.6816004,161.261418 L109.974451,161.261418 C117.191708,161.261418 123.042451,155.410675 123.042451,148.193417 L123.042451,45.3873499 C123.042451,41.9837684 121.714545,38.7144806 119.341192,36.2748979 L91.9811639,8.15136766 C88.5368112,4.61089777 83.8072085,2.61360006 78.8677255,2.61360006 L15.6816004,2.61360006 Z"
                      />
                    </g>
                    <path
                      d="M81.1528662,5.20238152 L81.1528662,31.1522426 C81.1528662,38.3694999 87.0036093,44.2202429 94.2208665,44.2202429 L120.420382,44.2202429"
                      id="Path-15"
                      stroke="#E5E5E5"
                      strokeWidth="5.22720012"
                    />
                    <path
                      d="M117.802548,44.2202429 L117.802548,148.230645 C117.802548,152.561 114.292102,156.071446 109.961748,156.071446 L5.23566879,156.071446"
                      id="Path-16"
                      stroke="#E5E5E5"
                      strokeWidth="5.22720012"
                    />
                    <path
                      d="M15.6816004,2.61360006 C8.46434309,2.61360006 2.61360006,8.46434309 2.61360006,15.6816004 L2.61360006,148.193417 C2.61360006,155.410675 8.46434309,161.261418 15.6816004,161.261418 L109.974451,161.261418 C117.191708,161.261418 123.042451,155.410675 123.042451,148.193417 L123.042451,45.3873499 C123.042451,41.9837684 121.714545,38.7144806 119.341192,36.2748979 L91.9811639,8.15136766 C88.5368112,4.61089777 83.8072085,2.61360006 78.8677255,2.61360006 L15.6816004,2.61360006 Z"
                      id="Rectangle-14"
                      stroke="#24283D"
                      strokeWidth="5.22720012"
                    />
                    <path
                      d="M68.0636943,2.60119076 L78.5477348,2.60119076 C82.8780892,2.60119076 86.388535,6.11163658 86.388535,10.4419909 L86.388535,31.1770612 C86.388535,35.5074156 89.8989808,39.0178614 94.2293352,39.0178614 L115.197416,39.0178614 C119.527771,39.0178614 123.038217,42.5283072 123.038217,46.8586616 L123.038217,62.4285782"
                      id="Path-2"
                      stroke="#24283D"
                      strokeWidth="5.22720012"
                    />
                  </g>
                  <g id="Rectangle-15">
                    <use fill="#FF864E" fillRule="evenodd" />
                    <rect
                      stroke="#24283D"
                      fill="#ff864e"
                      strokeWidth="5.22720012"
                      x="2.61360006"
                      y="109.262421"
                      width="52.3651566"
                      height="20.7847075"
                      rx="7.84080018"
                    />
                  </g>
                </g>
                <g
                  id="Group-3"
                  transform="translate(44.630573, 57.452393)"
                  fill="#24283D"
                >
                  <rect
                    id="Rectangle-61"
                    x="0"
                    y="0"
                    width="5.23566879"
                    height="5.20238152"
                    rx="2.60119076"
                  />
                  <rect
                    id="Rectangle-61"
                    x="10.4713376"
                    y="0"
                    width="41.8853503"
                    height="5.20238152"
                    rx="2.60119076"
                  />
                  <rect
                    id="Rectangle-61"
                    x="0"
                    y="15.6071446"
                    width="5.23566879"
                    height="5.20238152"
                    rx="2.60119076"
                  />
                  <rect
                    id="Rectangle-61"
                    x="10.4713376"
                    y="15.6071446"
                    width="41.8853503"
                    height="5.20238152"
                    rx="2.60119076"
                  />
                  <rect
                    id="Rectangle-61"
                    x="0"
                    y="31.2142891"
                    width="5.23566879"
                    height="5.20238152"
                    rx="2.60119076"
                  />
                  <rect
                    id="Rectangle-61"
                    x="10.4713376"
                    y="31.2142891"
                    width="41.8853503"
                    height="5.20238152"
                    rx="2.60119076"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const trash = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 146 161"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <path
        d="M10.3703704,15.5153631 L134.814815,15.5153631 L128.058071,141.315365 C127.69762,148.026389 126.901139,150.427754 125.500674,152.838252 C124.100209,155.24875 122.125185,157.120541 119.643046,158.389709 C117.160906,159.658876 114.72028,160.325419 107.999583,160.325419 L37.185602,160.325419 C30.4649056,160.325419 28.024279,159.658876 25.5421395,158.389709 C23.0600001,157.120541 21.0849761,155.24875 19.6845111,152.838252 C18.2840461,150.427754 17.4875647,148.026389 17.1271143,141.315365 L10.3703704,15.5153631 Z"
        id="path-1"
      />
      <rect
        id="path-2"
        x="0"
        y="5.17178771"
        width="145.185185"
        height="15.5153631"
        rx="7.75768156"
      />
      <path
        d="M62.2204433,0 L82.9647419,0 C87.2593075,-7.888989e-16 90.7407407,3.48143328 90.7407407,7.77599887 L90.7407407,10.3435754 L54.4444444,10.3435754 L54.4444444,7.77599887 C54.4444444,3.48143328 57.9258777,7.888989e-16 62.2204433,0 Z"
        id="path-3"
      />
    </defs>
    <g
      id="Manage-Users"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Manage-Users---Bulk-Delete"
        transform="translate(-1293.000000, -859.000000)"
      >
        <g id="Group" transform="translate(1293.000000, 859.000000)">
          <g id="Trash" transform="translate(0.407407, 0.674581)">
            <g id="Rectangle-58" fill="#fff">
              <use fill="#FFFFFF" fillRule="evenodd" />
              <path
                stroke="#24283D"
                strokeWidth="5.18399924"
                d="M13.1053228,18.1073628 L19.7153833,141.176349 C20.0243614,146.929038 20.5734225,149.208568 21.9257121,151.536146 C23.0762856,153.516527 24.6829295,155.039194 26.7221693,156.081898 C29.1189243,157.307406 31.4246208,157.733419 37.185602,157.733419 L107.999583,157.733419 C113.760564,157.733419 116.066261,157.307406 118.463016,156.081898 C120.502256,155.039194 122.1089,153.516527 123.259473,151.536146 C124.611763,149.208568 125.160824,146.929038 125.469802,141.176349 L132.079862,18.1073628 L13.1053228,18.1073628 Z"
              />
            </g>
            <path
              d="M127.037037,19.3942039 L120.915612,145.169745 C120.713988,149.312461 117.296426,152.567737 113.148806,152.567737 L23.3333333,152.567737"
              id="Path-53"
              stroke="#E5E5E5"
              strokeWidth="5.18399924"
            />
            <path
              d="M13.1053228,18.1073628 L19.7153833,141.176349 C20.0243614,146.929038 20.5734225,149.208568 21.9257121,151.536146 C23.0762856,153.516527 24.6829295,155.039194 26.7221693,156.081898 C29.1189243,157.307406 31.4246208,157.733419 37.185602,157.733419 L107.999583,157.733419 C113.760564,157.733419 116.066261,157.307406 118.463016,156.081898 C120.502256,155.039194 122.1089,153.516527 123.259473,151.536146 C124.611763,149.208568 125.160824,146.929038 125.469802,141.176349 L132.079862,18.1073628 L13.1053228,18.1073628 Z"
              id="Rectangle-58"
              stroke="#24283D"
              strokeWidth="5.18399924"
            />
            <rect
              id="Rectangle-13"
              fill="#24283D"
              transform="translate(99.874142, 85.401115) rotate(2.000000) translate(-99.874142, -85.401115) "
              x="97.2815492"
              y="51.7844946"
              width="5.18518519"
              height="67.2332402"
              rx="2.59199962"
            />
            <rect
              id="Rectangle-13"
              fill="#24283D"
              transform="translate(45.429697, 85.401115) scale(-1, 1) rotate(2.000000) translate(-45.429697, -85.401115) "
              x="42.8371048"
              y="51.7844946"
              width="5.18518519"
              height="67.2332402"
              rx="2.59199962"
            />
            <rect
              id="Rectangle-13"
              fill="#24283D"
              x="70"
              y="51.7178771"
              width="5.18518519"
              height="67.2332402"
              rx="2.59199962"
            />
            <g id="Group-22">
              <g id="Rectangle-59" fill="#FF864E">
                <use fill="#FF854B" fillRule="evenodd" />
                <rect
                  stroke="#24283D"
                  strokeWidth="5.18399924"
                  x="2.59199962"
                  y="7.76378733"
                  width="140.001186"
                  height="10.3313639"
                  rx="5.16568194"
                />
              </g>
              <g id="Rectangle-16" fill="#FF864E">
                <use fill="#24283D" fillRule="evenodd" />
                <path
                  stroke="#24283D"
                  strokeWidth="5.18399924"
                  d="M57.0365004,7.7515758 L88.1486888,7.7515758 C88.1355304,4.89976758 85.8196402,2.59199962 82.9647419,2.59199962 L62.2204433,2.59199962 C59.365545,2.59199962 57.0496548,4.89976758 57.0365004,7.7515758 Z"
                />
              </g>
            </g>
            <path
              d="M134.814815,10.3435754 L137.414106,10.3435754 C138.842256,10.3435754 140,11.5013195 140,12.9294693 L140,12.9294693 C140,14.357619 138.842256,15.5153631 137.414106,15.5153631 L134.814815,15.5153631 L134.814815,10.3435754 Z"
              id="Rectangle-60"
              fillOpacity="0.15"
              fill="#000000"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const uploadingFile = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 358 194"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <path
        d="M17.4239997,1.8372273e-15 L87.6976846,3.55271368e-15 C93.9725451,7.97323614e-15 99.9805652,2.53826811 104.354695,7.03725294 L134.788503,38.339765 C137.95066,41.5921823 139.719745,45.9495874 139.719745,50.485825 L139.719745,164.905412 C139.719745,174.528421 131.918755,182.329412 122.295746,182.329412 L17.4239997,182.329412 C7.80099039,182.329412 4.73119244e-15,174.528421 3.55271368e-15,164.905412 L-3.55271368e-15,17.4239997 C-4.73119244e-15,7.80099039 7.80099039,-5.33770922e-15 17.4239997,-7.10542736e-15 Z"
        id="path-1"
      />
      <rect
        id="path-2"
        x="0"
        y="119.658824"
        width="64.0382166"
        height="28.9411765"
        rx="8"
      />
      <ellipse
        id="path-3"
        cx="29.1082803"
        cy="28.9411765"
        rx="29.1082803"
        ry="28.9411765"
      />
    </defs>
    <g
      id="Manage-Users"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Manage-Users---Bulk-Edit---Uploading-File-"
        transform="translate(-1187.000000, -758.000000)"
      >
        <g id="Pop-Up" transform="translate(815.000000, 460.000000)">
          <g id="UploadingFile" transform="translate(372.000000, 298.000000)">
            <path
              d="M311.582282,193.446218 C317.459878,177.784858 320.675159,160.816183 320.675159,143.094591 C320.675159,64.1176104 256.817276,0.0941176471 178.044586,0.0941176471 C99.2718955,0.0941176471 35.4140127,64.1176104 35.4140127,143.094591 C35.4140127,161.025267 38.7056105,178.185154 44.7160369,194 C49.2260378,193.446218 307.420718,194 311.582282,193.446218 Z"
              id="Oval-9"
              fill="#F7F7F7"
            />
            <path
              d="M32.0023979,188 L325.51415,188 C327.112527,188 328.408268,189.295741 328.408268,190.894118 C328.408268,192.492495 327.112527,193.788235 325.51415,193.788235 L32.0023979,193.788235 C30.4040209,193.788235 29.1082803,192.492495 29.1082803,190.894118 C29.1082803,189.295741 30.4040209,188 32.0023979,188 Z M337.123417,188 L342.978494,188 C344.576871,188 345.872611,189.295741 345.872611,190.894118 C345.872611,192.492495 344.576871,193.788235 342.978494,193.788235 L337.123417,193.788235 C335.52504,193.788235 334.229299,192.492495 334.229299,190.894118 C334.229299,189.295741 335.52504,188 337.123417,188 Z M354.588385,188 L354.621806,188 C356.220183,188 357.515924,189.295741 357.515924,190.894118 C357.515924,192.492495 356.220183,193.788235 354.621806,193.788235 L354.588385,193.788235 C352.990008,193.788235 351.694268,192.492495 351.694268,190.894118 C351.694268,189.295741 352.990008,188 354.588385,188 Z M14.5374297,188 L20.3925066,188 C21.9908836,188 23.2866242,189.295741 23.2866242,190.894118 C23.2866242,192.492495 21.9908836,193.788235 20.3925066,193.788235 L14.5374297,193.788235 C12.9390527,193.788235 11.6433121,192.492495 11.6433121,190.894118 C11.6433121,189.295741 12.9390527,188 14.5374297,188 Z M2.89411765,188 L2.9275384,188 C4.52591544,188 5.82165605,189.295741 5.82165605,190.894118 C5.82165605,192.492495 4.52591544,193.788235 2.9275384,193.788235 L2.89411765,193.788235 C1.29574061,193.788235 1.95744733e-16,192.492495 0,190.894118 C-1.95744733e-16,189.295741 1.29574061,188 2.89411765,188 Z"
              id="Combined-Shape"
              fill="#24283D"
            />
            <g id="Group-16" transform="translate(102.363057, 10.670588)">
              <g id="Group-8" transform="translate(11.636943, 0.329412)">
                <g id="Rectangle-14" fill="#FFFFFF">
                  <use fill="#FFFFFF" fillRule="evenodd" />
                  <path
                    stroke="#24283D"
                    strokeWidth="5.80799991"
                    d="M17.4239997,2.90399995 C9.40482528,2.90399995 2.90399995,9.40482528 2.90399995,17.4239997 L2.90399995,164.905412 C2.90399995,172.924586 9.40482528,179.425412 17.4239997,179.425412 L122.295746,179.425412 C130.31492,179.425412 136.815745,172.924586 136.815745,164.905412 L136.815745,50.485825 C136.815745,46.705627 135.341507,43.0744561 132.706377,40.3641084 L102.272568,9.06159627 C98.4452052,5.12498455 93.1881875,2.90399995 87.6976846,2.90399995 L17.4239997,2.90399995 Z"
                  />
                </g>
                <path
                  d="M90.2356688,5.78823529 L90.2356688,34.6800002 C90.2356688,42.6991747 96.7364941,49.2 104.755669,49.2 L133.898089,49.2"
                  id="Path-15"
                  stroke="#E5E5E5"
                  strokeWidth="5.80799991"
                />
                <path
                  d="M130.987261,49.2 L130.987261,164.935059 C130.987261,169.746564 127.086766,173.647059 122.275261,173.647059 L5.82165605,173.647059"
                  id="Path-16"
                  stroke="#E5E5E5"
                  strokeWidth="5.80799991"
                />
                <path
                  d="M17.4239997,2.90399995 C9.40482528,2.90399995 2.90399995,9.40482528 2.90399995,17.4239997 L2.90399995,164.905412 C2.90399995,172.924586 9.40482528,179.425412 17.4239997,179.425412 L122.295746,179.425412 C130.31492,179.425412 136.815745,172.924586 136.815745,164.905412 L136.815745,50.485825 C136.815745,46.705627 135.341507,43.0744561 132.706377,40.3641084 L102.272568,9.06159627 C98.4452052,5.12498455 93.1881875,2.90399995 87.6976846,2.90399995 L17.4239997,2.90399995 Z"
                  id="Rectangle-14"
                  stroke="#24283D"
                  strokeWidth="5.80799991"
                />
                <path
                  d="M75.6815287,2.89411765 L87.345325,2.89411765 C92.1568296,2.89411765 96.0573248,6.79461284 96.0573248,11.6061175 L96.0573248,34.6997648 C96.0573248,39.5112695 99.95782,43.4117647 104.769325,43.4117647 L128.096917,43.4117647 C132.908422,43.4117647 136.808917,47.3122599 136.808917,52.1237646 L136.808917,69.4588235"
                  id="Path-2"
                  stroke="#24283D"
                  strokeWidth="5.80799991"
                />
              </g>
              <g id="Rectangle-15">
                <use fill="#FF864E" fillRule="evenodd" />
                <rect
                  stroke="#24283D"
                  fill="#FF864E"
                  strokeWidth="5.8"
                  x="2.9"
                  y="122.558824"
                  width="58.2382166"
                  height="23.1411765"
                  rx="8"
                />
              </g>
            </g>
            <g
              id="Group-3"
              transform="translate(151.847134, 75.341176)"
              fill="#24283D"
            >
              <rect
                id="Rectangle-61"
                x="0"
                y="0"
                width="5.82165605"
                height="5.78823529"
                rx="2.89411765"
              />
              <rect
                id="Rectangle-61"
                x="11.6433121"
                y="0"
                width="46.5732484"
                height="5.78823529"
                rx="2.89411765"
              />
              <rect
                id="Rectangle-61"
                x="0"
                y="17.3647059"
                width="5.82165605"
                height="5.78823529"
                rx="2.89411765"
              />
              <rect
                id="Rectangle-61"
                x="11.6433121"
                y="17.3647059"
                width="46.5732484"
                height="5.78823529"
                rx="2.89411765"
              />
              <rect
                id="Rectangle-61"
                x="0"
                y="34.7294118"
                width="5.82165605"
                height="5.78823529"
                rx="2.89411765"
              />
              <rect
                id="Rectangle-61"
                x="11.6433121"
                y="34.7294118"
                width="46.5732484"
                height="5.78823529"
                rx="2.89411765"
              />
            </g>
            <g id="Group-6" transform="translate(221.707006, 135.117647)">
              <g id="Oval" fill="#FF864E">
                <use fill="#FF864E" fillRule="evenodd" />
                <ellipse
                  stroke="#24283D"
                  strokeWidth="5.80799991"
                  cx="29.1082803"
                  cy="28.9411765"
                  rx="26.2042803"
                  ry="26.0371765"
                />
              </g>
              <path
                d="M29.1082803,57.8823529 C45.1843395,57.8823529 58.2165605,44.6744 58.2165605,28.1644588 C58.2165605,18.2584941 51.7480538,46.3253941 29.1082803,46.3253941 C6.46850672,46.3253941 0,18.2584941 0,28.1644588 C0,44.5771985 13.032221,57.8823529 29.1082803,57.8823529 Z"
                id="Oval-15"
                fillOpacity="0.2"
                fill="#000000"
              />
              <g
                id="Group-5"
                transform="translate(14.554140, 11.865900)"
                fill="#24283D"
              >
                <rect
                  id="Rectangle-2"
                  x="11.6433121"
                  y="8.68235294"
                  width="5.82165605"
                  height="21.7058824"
                  rx="2.90399995"
                />
                <g id="Group-7" transform="translate(2.328627, 1.736488)">
                  <rect
                    id="Rectangle"
                    transform="translate(8.233065, 9.343430) rotate(45.000000) translate(-8.233065, -9.343430) "
                    x="5.32223692"
                    y="0.661077309"
                    width="5.82165605"
                    height="17.3647059"
                    rx="2.90399995"
                  />
                  <rect
                    id="Rectangle"
                    transform="translate(16.470758, 9.343430) scale(-1, 1) rotate(45.000000) translate(-16.470758, -9.343430) "
                    x="13.55993"
                    y="0.661077309"
                    width="5.82165605"
                    height="17.3647059"
                    rx="2.90399995"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const people = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 512 512"
    preserveAspectRatio="xMidYMid meet"
  >
    <circle cx="256" cy="256" r="248.69" fill="#ddd" />
    <path
      d="M91.43,442.52Q155.06,387.65,256,387.66t164.57,54.86c-42.42,41.69-97.28,62.17-164.57,62.17S133.85,484.21,91.43,442.52Z"
      fill="#777"
    />
    <path
      d="M256,512C114.84,512,0,397.16,0,256S114.84,0,256,0,512,114.84,512,256,397.16,512,256,512Zm0-497.37C122.91,14.63,14.63,122.91,14.63,256S122.91,497.38,256,497.38,497.37,389.1,497.37,256,389.09,14.63,256,14.63Z"
      fill="#24283d"
    />
    <path
      d="M415.79,448.06C374.94,412.83,321.18,395,256,395S137.06,412.83,96.2,448.06L86.65,437C130.24,399.4,187.22,380.35,256,380.35s125.76,19,169.35,56.62Z"
      fill="#24283d"
    />
    <circle cx="256" cy="241.37" r="73.14" fill="#777" />
    <path
      d="M256,329.15a87.78,87.78,0,1,1,87.77-87.78A87.87,87.87,0,0,1,256,329.15Zm0-160.92a73.15,73.15,0,1,0,73.14,73.14A73.22,73.22,0,0,0,256,168.23Z"
      fill="#24283d"
    />
  </svg>
);

const noApplications = props => (
  <svg className={props.className} style={props.style} viewBox="0 0 136 82">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Illustrations" transform="translate(-621.000000, -1134.000000)">
        <g
          id="NoCustomApplications"
          transform="translate(621.000000, 1134.000000)"
        >
          <path
            d="M17,82 L11.9057162,58.5159582 C11.620434,57.2008416 11.7855383,55.8280009 12.3744998,54.6180249 L25.4143272,27.8287078 C25.7944225,27.0478314 26.4183354,26.4118736 27.191802,26.0169181 L43.9999916,17.4341479 C44.8901251,16.9796188 45.9181709,16.8747952 46.8817234,17.1403151 L80.5776728,26.4256878 C81.056849,26.5577313 81.5564378,26.5993118 82.0508496,26.5482996 L107.340471,23.9389777 C108.938425,23.7741047 110.479985,24.5811964 111.254878,25.9883852 L127.017656,54.6132532 C127.684571,55.8243574 127.912761,57.2286236 127.663636,58.5885819 L123.375,82 L17,82 Z"
            id="Path-45"
            fill="#F5F5F5"
            fillRule="nonzero"
          />
          <path
            d="M86.7234933,18 L134.775812,18 C135.451253,18 135.998807,17.4524464 135.998807,16.7770049 C135.998807,16.3824751 135.808482,16.0121759 135.487672,15.7825345 L133.628452,14.4516693 C132.809967,13.8657826 131.889028,13.4383109 130.913226,13.1913454 L125.367352,11.7877405 C124.105743,11.46844 122.940154,10.8485441 121.970123,9.98099039 L119.814659,8.0532377 C118.336229,6.73099404 116.422348,6 114.438896,6 L111.27182,6 C109.729287,6 108.249065,6.608693 107.152759,7.69382939 L107.152759,7.69382939 C106.056453,8.77896578 104.576231,9.38765878 103.033698,9.38765878 L101.364536,9.38765878 C99.2401348,9.38765878 97.2015489,10.2259607 95.6916984,11.7204281 L94.1721802,13.2244647 C93.1149863,14.2708874 91.7411006,14.9378693 90.264954,15.1213103 L90.1130839,15.1401832 C88.7214669,15.3131197 87.4006234,15.8520914 86.2852936,16.7021176 L86.2852936,16.7021176 C85.967748,16.9441287 85.9065151,17.397739 86.1485261,17.7152846 C86.285263,17.8946988 86.4979131,18 86.7234933,18 Z"
            id="Path-19"
            fill="#F5F5F5"
            transform="translate(111.000000, 12.000000) scale(-1, 1) translate(-111.000000, -12.000000) "
          />
          <path
            d="M0.783997758,13 L52.6735699,13 C53.4056415,13 53.9991028,12.4065387 53.9991028,11.674467 C53.9991028,11.2475417 53.7934747,10.8467497 53.4466861,10.5977457 L51.4238697,9.14530645 C50.5497553,8.51766766 49.5656618,8.05956942 48.5226415,7.79477675 L42.4949188,6.26451231 C41.1467828,5.92225957 39.9017131,5.25828326 38.866381,4.32946947 L36.4922499,2.19959682 C34.9135462,0.78331528 32.8673814,-4.9696916e-16 30.746495,1.77635684e-15 L27.2975406,-1.77635684e-15 C25.6293333,-1.46991213e-15 24.028795,0.659611099 22.8449795,1.83498184 L22.8449795,1.83498184 C21.661164,3.01035258 20.0606258,3.66996368 18.3924185,3.66996368 L16.5583423,3.66996368 C14.2870141,3.66996368 12.1078198,4.56804949 10.4960096,6.16836185 L8.82334956,7.82908992 C7.68338531,8.96092222 6.20022626,9.68271194 4.6061503,9.88141944 L4.44462758,9.90155385 C2.94016056,10.0890913 1.51258142,10.6731693 0.3081171,11.5939608 L0.3081171,11.5939608 C-0.0356732956,11.8567824 -0.101311448,12.3485386 0.161510182,12.692329 C0.309756506,12.8862463 0.539905781,13 0.783997758,13 Z"
            id="Path-19"
            fill="#F5F5F5"
          />
          <g id="Browser" transform="translate(18.000000, 22.000000)">
            <path
              d="M5.1277704,1 C3.65310186,1 3.09403919,1.10795998 2.51790745,1.41607861 C2.04032407,1.67149299 1.67149299,2.04032407 1.41607861,2.51790745 C1.10795998,3.09403919 1,3.65310186 1,5.1277704 L1,54.8722296 C1,56.3468981 1.10795998,56.9059608 1.41607861,57.4820925 C1.67149299,57.9596759 2.04032407,58.328507 2.51790745,58.5839214 C3.09403919,58.89204 3.65310186,59 5.1277704,59 L74.8722296,59 C76.3468981,59 76.9059608,58.89204 77.4820925,58.5839214 C77.9596759,58.328507 78.328507,57.9596759 78.5839214,57.4820925 C78.89204,56.9059608 79,56.3468981 79,54.8722296 L79,5.1277704 C79,3.65310186 78.89204,3.09403919 78.5839214,2.51790745 C78.328507,2.04032407 77.9596759,1.67149299 77.4820925,1.41607861 C76.9059608,1.10795998 76.3468981,1 74.8722296,1 L5.1277704,1 Z"
              id="Rectangle"
              stroke="#24283D"
              strokeWidth="2"
              fill="#FFFFFF"
            />
            <path
              d="M79,13 L79,56 C79,56.5522847 78.5522847,57 78,57 L3,57"
              id="Path-37"
              stroke="#000000"
              strokeWidth="2"
              opacity="0.08"
              fillRule="nonzero"
              transform="translate(41.000000, 35.000000) scale(-1, 1) translate(-41.000000, -35.000000) "
            />
            <path
              d="M5.1277704,1 C3.65310186,1 3.09403919,1.10795998 2.51790745,1.41607861 C2.04032407,1.67149299 1.67149299,2.04032407 1.41607861,2.51790745 C1.10795998,3.09403919 1,3.65310186 1,5.1277704 L1,54.8722296 C1,56.3468981 1.10795998,56.9059608 1.41607861,57.4820925 C1.67149299,57.9596759 2.04032407,58.328507 2.51790745,58.5839214 C3.09403919,58.89204 3.65310186,59 5.1277704,59 L74.8722296,59 C76.3468981,59 76.9059608,58.89204 77.4820925,58.5839214 C77.9596759,58.328507 78.328507,57.9596759 78.5839214,57.4820925 C78.89204,56.9059608 79,56.3468981 79,54.8722296 L79,5.1277704 C79,3.65310186 78.89204,3.09403919 78.5839214,2.51790745 C78.328507,2.04032407 77.9596759,1.67149299 77.4820925,1.41607861 C76.9059608,1.10795998 76.3468981,1 74.8722296,1 L5.1277704,1 Z"
              id="Rectangle"
              stroke="#24283D"
              strokeWidth="2"
            />
            <path
              d="M1,12 L79,12 L79,5.1277704 C79,3.65310186 78.89204,3.09403919 78.5839214,2.51790745 C78.328507,2.04032407 77.9596759,1.67149299 77.4820925,1.41607861 C76.9059608,1.10795998 76.3468981,1 74.8722296,1 L5.1277704,1 C3.65310186,1 3.09403919,1.10795998 2.51790745,1.41607861 C2.04032407,1.67149299 1.67149299,2.04032407 1.41607861,2.51790745 C1.10795998,3.09403919 1,3.65310186 1,5.1277704 L1,12 Z"
              id="Rectangle"
              stroke="#24283D"
              strokeWidth="2"
              fill="#FFFFFF"
            />
            <circle
              id="Oval"
              fill="#24283D"
              fillRule="nonzero"
              cx="6.5"
              cy="6.5"
              r="1.5"
            />
            <circle
              id="Oval"
              fill="#24283D"
              fillRule="nonzero"
              cx="11.5"
              cy="6.5"
              r="1.5"
            />
            <circle
              id="Oval"
              fill="#24283D"
              fillRule="nonzero"
              cx="16.5"
              cy="6.5"
              r="1.5"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="7"
              y="18"
              width="20"
              height="12"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="7"
              y="37"
              width="20"
              height="12"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="30"
              y="18"
              width="20"
              height="12"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="30"
              y="37"
              width="20"
              height="12"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="53"
              y="18"
              width="20"
              height="12"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="53"
              y="37"
              width="20"
              height="12"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="7"
              y="51"
              width="13"
              height="1.5"
              rx="0.75"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="30"
              y="51"
              width="13"
              height="1.5"
              rx="0.75"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="53"
              y="51"
              width="13"
              height="1.5"
              rx="0.75"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="53"
              y="32"
              width="13"
              height="1.5"
              rx="0.75"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="30"
              y="32"
              width="13"
              height="1.5"
              rx="0.75"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              fillRule="nonzero"
              x="7"
              y="32"
              width="13"
              height="1.5"
              rx="0.75"
            />
          </g>
          <path
            d="M83,78 L83,35"
            id="Path-38"
            stroke="#000000"
            strokeWidth="2"
            opacity="0.08"
            fillRule="nonzero"
          />
          <g
            id="iPad"
            transform="translate(84.000000, 28.000000)"
            fillRule="nonzero"
          >
            <rect
              id="Rectangle"
              stroke="#24283D"
              strokeWidth="2"
              fill="#FFFFFF"
              x="1"
              y="1"
              width="36"
              height="52"
              rx="4"
            />
            <path
              d="M1,8 L1,46 L37,46 L37,8 L1,8 Z"
              id="Rectangle"
              stroke="#24283D"
              strokeWidth="2"
              fill="#FFFFFF"
            />
            <circle id="Oval" fill="#24283D" cx="19" cy="49.5" r="1.5" />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              x="5"
              y="13"
              width="12"
              height="6"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              x="5"
              y="21"
              width="10"
              height="1.5"
              rx="0.5"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              x="21"
              y="21"
              width="10"
              height="1.5"
              rx="0.5"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              x="21"
              y="35"
              width="10"
              height="1.5"
              rx="0.5"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              x="5"
              y="35"
              width="10"
              height="1.5"
              rx="0.5"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              x="21"
              y="13"
              width="12"
              height="6"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              x="5"
              y="27"
              width="12"
              height="6"
              rx="1"
            />
            <rect
              id="Rectangle"
              fill="#EEEEEE"
              x="21"
              y="27"
              width="12"
              height="6"
              rx="1"
            />
          </g>
          <g id="Cog" transform="translate(76.180000, 64.000000)">
            <circle
              id="Oval"
              fill="#FFFFFF"
              fillRule="nonzero"
              cx="8.5"
              cy="7.5"
              r="3.5"
            />
            <path
              d="M3.31237332,13.9268669 C2.62743304,13.3074828 2.06526491,12.5791393 1.63896073,11.7807759 L2.87774016,9.20183009 L0.697873756,7.42177109 C0.755333335,6.52001564 0.962990016,5.61289478 1.33303414,4.73666687 L4.08528398,4.07972847 L4.12672033,1.22731229 C4.8795043,0.687305956 5.71458831,0.281775492 6.59203669,0.0249546729 L8.78536344,1.7841402 L11.0161325,0.00697239393 C11.4460602,0.130683822 11.8710163,0.292733133 12.286789,0.494621491 C12.7025617,0.696509849 13.0927057,0.930251866 13.4557961,1.19160933 L13.4387228,4.04369009 L16.1775626,4.67943589 C16.5183597,5.5278049 16.7160937,6.43484487 16.757254,7.36036979 L14.5412877,9.15689097 L15.7270425,11.7260217 C15.2672912,12.5586901 14.6828406,13.2828497 14.0097234,13.8856579 L11.2628041,13.2733983 L10.0021933,15.8417434 C9.11116394,16.0004439 8.19114064,16.009074 7.28082054,15.8538413 L6.07203711,13.2933981 L3.31237332,13.9268669 Z M7.96223642,9.49069647 C8.87140246,9.93216378 9.96678217,9.55204071 10.4088355,8.64166784 C10.8508888,7.73129498 10.4722191,6.63541199 9.56305305,6.19394469 C8.65388701,5.75247739 7.5585073,6.13260046 7.11645399,7.04297332 C6.67440069,7.95334619 7.05307038,9.04922917 7.96223642,9.49069647 Z"
              id="Shape"
              stroke="#24283D"
              strokeWidth="2"
              fill="#FF864E"
            />
            <polyline
              id="Path-44"
              strokeOpacity="0.15"
              stroke="#000000"
              strokeWidth="2"
              fillRule="nonzero"
              points="1.1863413 7.82666016 4.09880859 9 2.71343262 11.7113037 3.61266357 12.8356323 6.64208252 12.1539917 7.92046387 14.8021851 9.31627686 14.8021851 10.7047656 12.1539917 13.6932553 12.8356323 14.6210254 11.7113037 13.3507617 8.87664795 16.1721729 7.82666016"
            />
            <path
              d="M3.31237332,13.9268669 C2.62743304,13.3074828 2.06526491,12.5791393 1.63896073,11.7807759 L2.87774016,9.20183009 L0.697873756,7.42177109 C0.755333335,6.52001564 0.962990016,5.61289478 1.33303414,4.73666687 L4.08528398,4.07972847 L4.12672033,1.22731229 C4.8795043,0.687305956 5.71458831,0.281775492 6.59203669,0.0249546729 L8.78536344,1.7841402 L11.0161325,0.00697239393 C11.4460602,0.130683822 11.8710163,0.292733133 12.286789,0.494621491 C12.7025617,0.696509849 13.0927057,0.930251866 13.4557961,1.19160933 L13.4387228,4.04369009 L16.1775626,4.67943589 C16.5183597,5.5278049 16.7160937,6.43484487 16.757254,7.36036979 L14.5412877,9.15689097 L15.7270425,11.7260217 C15.2672912,12.5586901 14.6828406,13.2828497 14.0097234,13.8856579 L11.2628041,13.2733983 L10.0021933,15.8417434 C9.11116394,16.0004439 8.19114064,16.009074 7.28082054,15.8538413 L6.07203711,13.2933981 L3.31237332,13.9268669 Z M7.96223642,9.49069647 C8.87140246,9.93216378 9.96678217,9.55204071 10.4088355,8.64166784 C10.8508888,7.73129498 10.4722191,6.63541199 9.56305305,6.19394469 C8.65388701,5.75247739 7.5585073,6.13260046 7.11645399,7.04297332 C6.67440069,7.95334619 7.05307038,9.04922917 7.96223642,9.49069647 Z"
              id="Shape"
              stroke="#24283D"
              strokeWidth="2"
            />
          </g>
          <g
            id="Line"
            transform="translate(4.000000, 80.000000)"
            fill="#24283D"
          >
            <rect id="Rectangle-9" x="9" y="0" width="114" height="2" rx="1" />
            <rect id="Rectangle-9" x="4" y="0" width="4" height="2" rx="1" />
            <rect id="Rectangle-9" x="0" y="0" width="2" height="2" rx="1" />
            <rect id="Rectangle-9" x="124" y="0" width="4" height="2" rx="1" />
            <rect id="Rectangle-9" x="130" y="0" width="2" height="2" rx="1" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const warning = props => (
  <svg className={props.className} style={props.style} viewBox="0 0 200 120">
    <path
      d="M178.1,41H117.53a1.53,1.53,0,0,1-.88-2.77L119,36.55A10.18,10.18,0,0,1,122.4,35l7-1.77A10.07,10.07,0,0,0,133.67,31l2.76-2.45a10.09,10.09,0,0,1,6.7-2.54h4.05a7.38,7.38,0,0,1,5.18,2.12,7.41,7.41,0,0,0,5.18,2.11h2.17a10.06,10.06,0,0,1,7.06,2.9l1.94,1.9a8.55,8.55,0,0,0,4.93,2.37l.2,0a9.92,9.92,0,0,1,4.81,2,.9.9,0,0,1-.54,1.62Z"
      fill="#eee"
      fillRule="evenodd"
    />
    <path
      d="M22,40h64.4A1.64,1.64,0,0,0,88,38.38,1.66,1.66,0,0,0,87.31,37l-2.5-1.78a10.71,10.71,0,0,0-3.61-1.67l-7.47-1.88a10.7,10.7,0,0,1-4.52-2.4l-2.92-2.59A10.76,10.76,0,0,0,59.14,24H54.86a7.85,7.85,0,0,0-5.52,2.26,7.82,7.82,0,0,1-5.5,2.26H41.55A10.75,10.75,0,0,0,34,31.61l-2,2a9,9,0,0,1-5.24,2.53l-.21,0a10.68,10.68,0,0,0-5.13,2.08A1,1,0,0,0,22,40Z"
      fill="#eee"
      fillRule="evenodd"
    />
    <path
      d="M138.93,115.75A46.73,46.73,0,0,0,145,92.6C145,66.86,124.4,46,99,46S53,66.86,53,92.6A47.08,47.08,0,0,0,59.21,116C67.53,115.9,129.26,116,138.93,115.75Z"
      fill="#f5f5f5"
      fillRule="evenodd"
    />
    <path
      d="M45,114H153a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H45a1,1,0,0,1-1-1h0A1,1,0,0,1,45,114Z"
      fill="#24283d"
      fillRule="evenodd"
    />
    <path
      d="M157,114h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1h0A1,1,0,0,1,157,114Z"
      fill="#24283d"
      fillRule="evenodd"
    />
    <path
      d="M163,114h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1h0A1,1,0,0,1,163,114Z"
      fill="#24283d"
      fillRule="evenodd"
    />
    <path
      d="M39,114h2a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H39a1,1,0,0,1-1-1h0A1,1,0,0,1,39,114Z"
      fill="#24283d"
      fillRule="evenodd"
    />
    <path
      d="M35,114h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1h0A1,1,0,0,1,35,114Z"
      fill="#24283d"
      fillRule="evenodd"
    />
    <path
      d="M106.65,49.4a7,7,0,0,0-12.3,0l-30,55.26A7,7,0,0,0,70.46,115h60.08a7,7,0,0,0,6.15-10.34Z"
      fill="#fff"
      stroke="#24283d"
      strokeWidth="2"
      fillRule="evenodd"
    />
    <path
      d="M102.22,46l32.69,59.6a5,5,0,0,1-4.39,7.4H66"
      fill="none"
      stroke="#000"
      strokeOpacity="0.12"
      strokeWidth="2"
    />
    <path
      d="M102.7,91.8H99.35a2,2,0,0,1-2-1.9L96.13,66.32A3,3,0,0,1,99,63.17h4a3,3,0,0,1,3,3v.15L104.7,89.9A2,2,0,0,1,102.7,91.8Z"
      fill="#ff854b"
      stroke="#24283d"
      strokeWidth="2"
      fillRule="evenodd"
    />
    <path
      d="M95.84,101.81a4.91,4.91,0,0,1,1.32-3.72A5.35,5.35,0,0,1,101,96.83a5.17,5.17,0,0,1,3.76,1.29,5.68,5.68,0,0,1,0,7.34,5.12,5.12,0,0,1-3.75,1.33,5.21,5.21,0,0,1-3.8-1.3A4.88,4.88,0,0,1,95.84,101.81Z"
      fill="#ff854b"
      stroke="#24283d"
      strokeWidth="2"
      fillRule="evenodd"
    />
  </svg>
);

const email = props => (
  <svg
    className={props.className}
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 120"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#F7F7F7"
        fillOpacity=".9"
        d="M144.97 115.82A46.83 46.83 0 0 0 148 99.2c0-26.07-21.27-47.2-47.5-47.2S53 73.13 53 99.2c0 5.92 1.1 11.58 3.1 16.8 1.5-.18 87.49 0 88.87-.18z"
      />
      <rect
        width="64"
        height="46"
        x="69"
        y="69"
        fill="#FFFFFF"
        stroke="#24283D"
        strokeWidth="2"
        rx="6"
      />
      <path
        stroke="#E3E3E3"
        strokeWidth="2"
        d="M69 74.5l27.07 21.15a8 8 0 0 0 9.86 0L131 76h0v34a3 3 0 0 1-3 3H70h0"
      />
      <line x1="70" x2="94" y1="113" y2="91" stroke="#24283D" strokeWidth="2" />
      <line
        x1="108"
        x2="132"
        y1="91"
        y2="113"
        stroke="#24283D"
        strokeWidth="2"
      />
      <rect
        width="64"
        height="46"
        x="69"
        y="69"
        stroke="#24283D"
        strokeWidth="2"
        rx="6"
      />
      <path
        stroke="#24283D"
        strokeWidth="2"
        d="M71 70a2.5 2.5 0 0 0 .23 3.74L97.3 94.11a6 6 0 0 0 7.38 0l26.08-20.37A2.5 2.5 0 0 0 131 70h0"
      />
      <rect width="140" height="2" x="30" y="114" fill="#24283D" rx="1" />
      <rect width="4" height="2" x="24" y="114" fill="#24283D" rx="1" />
      <rect width="2" height="2" x="20" y="114" fill="#24283D" rx="1" />
      <rect width="4" height="2" x="172" y="114" fill="#24283D" rx="1" />
      <rect width="2" height="2" x="178" y="114" fill="#24283D" rx="1" />
      <path
        fill="#EEEEEE"
        d="M178.1 47h-60.57a1.53 1.53 0 0 1-.88-2.77l2.35-1.68a10.08 10.08 0 0 1 3.4-1.55l7.04-1.77c1.57-.4 3.02-1.16 4.23-2.24l2.76-2.45a10.08 10.08 0 0 1 6.7-2.54h4.05c1.94 0 3.8.76 5.18 2.12a7.4 7.4 0 0 0 5.18 2.11h2.17c2.64 0 5.17 1.04 7.06 2.9l1.94 1.9a8.53 8.53 0 0 0 4.93 2.37l.2.03c1.74.21 3.4.88 4.81 1.95a.9.9 0 0 1-.54 1.62zM22.96 45h64.4a1.63 1.63 0 0 0 .95-2.96l-2.5-1.78a10.76 10.76 0 0 0-3.61-1.67l-7.47-1.88a10.76 10.76 0 0 1-4.52-2.4l-2.92-2.59A10.76 10.76 0 0 0 60.14 29h-4.28c-2.07 0-4.05.81-5.52 2.26a7.85 7.85 0 0 1-5.5 2.26h-2.29a10.7 10.7 0 0 0-7.54 3.09l-2.05 2.02a9.05 9.05 0 0 1-5.24 2.53l-.21.03c-1.87.23-3.63.95-5.13 2.08a.96.96 0 0 0 .58 1.73z"
      />
    </g>
  </svg>
);

const webLink = props => (
  <svg
    className={props.className}
    style={props.style}
    viewBox="0 0 200 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M138.929 115.755C140.292 113.347 141.45 110.803 142.377 108.15C144.076 103.287 145 98.0526 145 92.5999C145 66.8635 124.405 46 99 46C73.5949 46 53 66.8635 53 92.5999C53 98.0578 53.9262 103.296 55.6281 108.163C56.5858 110.902 57.7891 113.524 59.2113 116C67.5263 115.9 129.263 116 138.929 115.755Z"
      fill="#F5F5F5"
    />
    <rect x="162" y="114" width="2" height="2" rx="1" fill="#24283D" />
    <rect x="156" y="114" width="4" height="2" rx="1" fill="#24283D" />
    <rect x="44" y="114" width="110" height="2" rx="1" fill="#24283D" />
    <rect x="38" y="114" width="4" height="2" rx="1" fill="#24283D" />
    <rect x="34" y="114" width="2" height="2" rx="1" fill="#24283D" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176.849 38.0235C178.116 38.9812 177.439 41 175.851 41H121.776C118.969 41 117.819 37.395 120.107 35.7698C120.399 35.5626 120.727 35.4116 121.074 35.3245L129.426 33.2274C130.997 32.833 132.45 32.0658 133.661 30.9909L136.423 28.54C138.268 26.9037 140.648 26 143.113 26H147.169C149.106 26 150.966 26.7603 152.348 28.1173C153.729 29.4743 155.589 30.2346 157.526 30.2346H159.697C162.339 30.2346 164.875 31.2715 166.76 33.1223L168.456 34.7881C169.949 36.2537 171.883 37.1867 173.959 37.4426L176.053 37.7009C176.343 37.7365 176.617 37.8478 176.849 38.0235Z"
      fill="#EEEEEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.2855 36.8262C21.9367 37.849 22.6601 40 24.3528 40H81.8506C84.843 40 86.0712 36.1586 83.6338 34.4225C83.3223 34.2006 82.9721 34.0388 82.6012 33.9454L73.7339 31.7124C72.0552 31.2896 70.5035 30.468 69.2103 29.3172L66.2927 26.7208C64.3233 24.9682 61.7789 24 59.1426 24H54.8563C52.7938 24 50.8141 24.8112 49.3447 26.2584C47.8753 27.7057 45.8955 28.5169 43.8331 28.5169H41.5521C38.7279 28.5169 36.0171 29.6277 34.005 31.6094L32.2095 33.3777C30.6248 34.9385 28.5692 35.9325 26.3618 36.2054L24.136 36.4806C23.827 36.5189 23.5336 36.6381 23.2855 36.8262Z"
      fill="#EEEEEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.5 114C117.449 114 132 99.4493 132 81.5C132 63.5507 117.449 49 99.5 49C81.5507 49 67 63.5507 67 81.5C67 99.4493 81.5507 114 99.5 114Z"
      fill="white"
    />
    <path
      d="M67 83H132"
      stroke="#E5E5E5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.5 112.5C116.173 112.5 130.5 98.6208 130.5 81.5C130.5 64.3792 116.173 50.5 98.5 50.5"
      stroke="#E5E5E5"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.5 114C117.449 114 132 99.4493 132 81.5C132 63.5507 117.449 49 99.5 49C81.5507 49 67 63.5507 67 81.5C67 99.4493 81.5507 114 99.5 114Z"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.5 114C108.613 114 116 99.4493 116 81.5C116 63.5507 108.613 49 99.5 49C90.3873 49 83 63.5507 83 81.5C83 99.4493 90.3873 114 99.5 114Z"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path
      d="M120.5 56C120.5 59.3137 111.098 62 99.5 62C87.902 62 78.5 59.3137 78.5 56"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path
      d="M120.5 106C120.5 102.686 111.098 100 99.5 100C87.902 100 78.5 102.686 78.5 106"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path
      d="M67 81H132"
      stroke="#24283D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M99.5 49.5V112.5"
      stroke="#24283D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="79" y="78" width="42" height="7" rx="3.5" fill={props.fill} />
    <path
      d="M79 83H121C121 84.1046 120.105 85 119 85H81C79.8954 85 79 84.1046 79 83Z"
      fill="black"
      fillOpacity="0.15"
    />
    <rect
      x="79"
      y="78"
      width="42"
      height="7"
      rx="3.5"
      stroke="#24283D"
      strokeWidth="2"
    />
  </svg>
);

const salesAI = props => (
  <svg
    width="90"
    height="20"
    fill="none"
    style={props.salesAI}
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.186 16.038c0-.23.092-.461.255-.692.162-.23.37-.346.58-.346.139 0 .301.092.51.277.209.184.44.392.65.623.231.23.58.438 1.066.623a4.52 4.52 0 0 0 1.624.277c.974 0 1.74-.23 2.296-.715.557-.462.835-1.177.835-2.077 0-.831-.255-1.5-.765-2.008a5.303 5.303 0 0 0-1.856-1.177c-.719-.277-1.461-.554-2.18-.877-.742-.3-1.345-.784-1.856-1.408C.835 7.892.58 7.085.58 6.07c0-.784.139-1.477.464-2.054C1.345 3.438 1.74 3 2.25 2.7c.51-.3 1.02-.508 1.577-.646a6.91 6.91 0 0 1 1.74-.208c.927 0 1.832.139 2.69.416.858.276 1.276.646 1.276 1.13 0 .208-.07.439-.232.67-.162.23-.348.369-.58.369-.07 0-.417-.139-1.044-.439a5.225 5.225 0 0 0-2.11-.438c-.928 0-1.67.184-2.227.554-.557.369-.858.969-.858 1.777 0 .692.255 1.246.765 1.684.51.439 1.137.762 1.856 1.016.742.253 1.461.553 2.18.877.719.323 1.345.853 1.856 1.592.51.738.765 1.661.765 2.769 0 1.546-.44 2.723-1.369 3.508-.904.784-2.11 1.177-3.595 1.177-1.345 0-2.481-.277-3.41-.831-.88-.53-1.344-1.085-1.344-1.639z"
      fill="#414042"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2 17.471a.516.516 0 0 0-.02.09c0 .231.116.416.348.623.231.162.51.231.765.231.371 0 .603-.138.696-.438l.997-3.323h5.984l.998 3.323c.092.277.301.415.672.415.302 0 .557-.07.812-.23.255-.162.371-.324.371-.531v-.162L18.184 2.446c-.139-.438-.533-.67-1.16-.67-.649 0-1.02.209-1.16.647l-4.638 14.954a3.872 3.872 0 0 1-.025.094zm8.306-4.456H14.45l2.551-8.469 2.505 8.47z"
      fill="#414042"
    />
    <path
      d="M24.841 17.677V2.56c0-.207.093-.369.278-.484.186-.116.418-.162.673-.162.255 0 .487.046.673.162a.542.542 0 0 1 .278.484v14.077h6.17c.185 0 .348.093.44.254.116.162.163.37.163.6 0 .23-.047.415-.163.6-.116.162-.255.254-.44.254h-7.214c-.232 0-.417-.07-.603-.185-.185-.092-.255-.277-.255-.484zM35.418 17.677V2.585a.57.57 0 0 1 .255-.485c.162-.115.371-.185.603-.185h8.048c.21 0 .371.093.487.254.116.162.163.37.163.577 0 .23-.07.439-.186.623a.565.565 0 0 1-.464.254H37.32v5.723h3.525c.186 0 .348.07.464.23a.954.954 0 0 1 .186.578c0 .184-.047.369-.163.53-.116.162-.278.231-.487.231H37.32v5.746h7.004c.186 0 .348.093.464.254.116.162.186.37.186.623 0 .231-.047.416-.163.577a.575.575 0 0 1-.487.254h-8.048c-.232 0-.418-.07-.603-.185a.612.612 0 0 1-.255-.507zM46.18 16.038c0-.23.093-.461.255-.692.162-.23.37-.346.58-.346.139 0 .301.092.51.277.209.184.44.392.65.623.231.23.58.438 1.066.623a4.52 4.52 0 0 0 1.624.277c.974 0 1.74-.23 2.296-.715.557-.462.835-1.177.835-2.077 0-.831-.255-1.5-.765-2.008a5.302 5.302 0 0 0-1.856-1.177c-.719-.277-1.461-.554-2.18-.877-.742-.3-1.345-.784-1.856-1.408-.51-.646-.765-1.453-.765-2.469 0-.784.14-1.477.464-2.054.301-.577.696-1.015 1.206-1.315.51-.3 1.02-.508 1.577-.646a7.044 7.044 0 0 1 1.74-.208c.928 0 1.832.139 2.69.416.858.276 1.276.646 1.276 1.13 0 .208-.07.439-.232.67-.162.23-.348.369-.58.369-.07 0-.417-.139-1.044-.439a5.225 5.225 0 0 0-2.11-.438c-.928 0-1.67.184-2.227.554-.557.369-.858.969-.858 1.777 0 .692.255 1.246.765 1.684.51.439 1.137.762 1.856 1.016.742.253 1.461.553 2.18.877.72.323 1.345.853 1.856 1.592.51.738.765 1.661.765 2.769 0 1.546-.44 2.723-1.345 3.508-.905.784-2.11 1.177-3.595 1.177-1.346 0-2.482-.277-3.41-.831-.904-.53-1.368-1.085-1.368-1.639z"
      fill="#414042"
    />
    <path
      d="M77.562 18.3c1.275-.462 2.064-1.592 2.064-2.93 0-.393-.07-.785-.232-1.155L73.247 1.87C72.576.485 71.254.115 70.442.115h-.186c-.765.024-2.226.439-2.899 1.8l-6.03 12.093-.093.207c-.14.37-.232.762-.232 1.154 0 1.339.789 2.47 2.064 2.931h.024c.904.323 1.878.254 2.644-.162a3.15 3.15 0 0 0 1.391-1.407l3.178-6.439 3.154 6.439a3.1 3.1 0 0 0 1.369 1.407c.812.439 1.763.485 2.69.162h.047z"
      fill="url(#a)"
    />
    <path
      d="M70.44.115h-.185c-.765.024-2.226.439-2.899 1.8l-1.995 4.062 4.94 4.338c.024 0 .928-10.2.14-10.2z"
      fill="url(#b)"
    />
    <path
      d="m75.752 6.97-2.528-5.1C72.552.484 71.23.114 70.418.114c-.07 0-.116 10.2-.116 10.2l1.67 3.37 3.78-6.716z"
      fill="url(#c)"
    />
    <path
      d="M84.752.023h-.789a3.382 3.382 0 0 0-3.386 3.37v11.745c0 1.87 1.53 3.37 3.386 3.37h.766a3.382 3.382 0 0 0 3.386-3.37V3.393c.023-1.846-1.508-3.369-3.363-3.369z"
      fill="url(#d)"
    />
    <path
      d="M84.752.023h-.789a3.382 3.382 0 0 0-3.386 3.37v3.715c0 1.869 1.53 3.369 3.386 3.369h.766a3.382 3.382 0 0 0 3.386-3.37V3.393c.023-1.846-1.508-3.369-3.363-3.369z"
      fill="url(#e)"
    />
    <path
      d="m80.577 3.392 7.561 3.716v4.2l-7.561 3.854V3.392z"
      fill="url(#f)"
    />
    <path
      d="m68.377 14.238-1.23 2.493a3.101 3.101 0 0 1-1.368 1.407c-.812.439-1.763.485-2.69.162h-.024c-.974-.37-1.67-1.131-1.948-2.054l7.26-2.008z"
      fill="url(#g)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="79.615"
        y1=".133"
        x2="61.018"
        y2=".133"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CE2E08" />
        <stop offset=".066" stopColor="#D33807" />
        <stop offset=".245" stopColor="#DF4E06" />
        <stop offset=".443" stopColor="#E85D05" />
        <stop offset=".672" stopColor="#EC6604" />
        <stop offset="1" stopColor="#EE6904" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="65.234"
        y1="7.132"
        x2="72.189"
        y2="9.445"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F42C05" />
        <stop offset=".142" stopColor="#DF2706" />
        <stop offset=".541" stopColor="#A7190A" />
        <stop offset=".839" stopColor="#85100C" />
        <stop offset="1" stopColor="#780D0D" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="69.391"
        y1="1.715"
        x2="76.043"
        y2="11.875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F42C05" />
        <stop offset=".146" stopColor="#EE2A05" />
        <stop offset=".345" stopColor="#DC2607" />
        <stop offset=".576" stopColor="#BF1F08" />
        <stop offset=".828" stopColor="#97150B" />
        <stop offset="1" stopColor="#780D0D" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="80.586"
        y1=".027"
        x2="80.586"
        y2="18.53"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E11F05" />
        <stop offset="1" stopColor="#780D0D" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="80.585"
        y1=".027"
        x2="80.585"
        y2="10.492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F42C05" />
        <stop offset=".224" stopColor="#D22307" />
        <stop offset=".578" stopColor="#A1170A" />
        <stop offset=".848" stopColor="#83100C" />
        <stop offset="1" stopColor="#780D0D" />
      </linearGradient>
      <linearGradient
        id="f"
        x1="78.641"
        y1="5.279"
        x2="84.54"
        y2="14.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BE1A08" />
        <stop offset="1" stopColor="#EE6904" />
      </linearGradient>
      <linearGradient
        id="g"
        x1="68.296"
        y1="18.215"
        x2="68.079"
        y2="14.685"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F42C05" />
        <stop offset=".167" stopColor="#E62806" />
        <stop offset=".484" stopColor="#C01F08" />
        <stop offset=".915" stopColor="#85100C" />
        <stop offset="1" stopColor="#780D0D" />
      </linearGradient>
    </defs>
  </svg>
);
const microsoftExchange = props => (
  <svg
    className={props.className}
    style={props.style}
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M426.735 85.334H339.93C336.671 85.3337 333.443 85.9758 330.432 87.2234C327.421 88.471 324.686 90.2997 322.382 92.6051L117.492 297.494C115.187 299.798 113.358 302.534 112.111 305.545C110.863 308.556 110.221 311.783 110.222 315.042V401.847C110.221 405.107 110.863 408.334 112.11 411.346C113.358 414.357 115.186 417.093 117.49 419.398C119.795 421.703 122.531 423.531 125.543 424.778C128.554 426.026 131.781 426.668 135.041 426.667H221.846C225.106 426.668 228.333 426.026 231.344 424.778C234.355 423.53 237.091 421.702 239.395 419.396L444.287 214.507C448.941 209.853 451.555 203.541 451.555 196.959V110.154C451.555 106.894 450.913 103.667 449.666 100.655C448.419 97.644 446.591 94.9077 444.286 92.6029C441.981 90.2981 439.245 88.4699 436.234 87.2227C433.222 85.9755 429.995 85.3337 426.735 85.334V85.334Z"
      fill="#28A8EA"
    />
    <path
      d="M426.737 426.667H339.929C333.347 426.667 327.035 424.052 322.381 419.398L280.887 377.904V300.373C280.887 288.605 285.562 277.318 293.884 268.997C302.205 260.675 313.492 256 325.261 256H402.793L444.286 297.493C448.94 302.148 451.555 308.46 451.555 315.042V401.849C451.555 408.431 448.94 414.743 444.286 419.398C439.631 424.052 433.319 426.667 426.737 426.667Z"
      fill="#0078D4"
    />
    <path
      d="M135.039 85.334H221.846C228.428 85.334 234.741 87.9487 239.395 92.603L280.888 134.096V211.627C280.888 217.455 279.741 223.225 277.511 228.608C275.281 233.992 272.012 238.884 267.892 243.004C263.771 247.124 258.88 250.393 253.496 252.623C248.112 254.853 242.342 256.001 236.515 256.001H158.983L117.49 214.507C112.836 209.853 110.222 203.541 110.222 196.959V110.152C110.222 103.57 112.836 97.2572 117.491 92.6029C122.145 87.9487 128.457 85.334 135.039 85.334V85.334Z"
      fill="#50D9FF"
    />
    <path
      opacity="0.2"
      d="M266.666 173.012V360.319C266.681 361.274 266.586 362.229 266.381 363.162C265.735 367.009 263.742 370.501 260.759 373.015C257.776 375.529 253.997 376.902 250.096 376.888H110.221V156.443H250.096C252.273 156.44 254.429 156.866 256.441 157.697C258.453 158.528 260.281 159.749 261.821 161.288C263.36 162.827 264.58 164.655 265.412 166.667C266.243 168.679 266.669 170.835 266.665 173.012H266.666Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M273.777 173.014V346.098C273.718 352.361 271.204 358.35 266.776 362.778C262.348 367.206 256.358 369.72 250.096 369.778H110.221V149.334H250.096C256.37 149.356 262.38 151.858 266.816 156.294C271.252 160.73 273.754 166.74 273.776 173.014H273.777Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M266.666 173.012V346.097C266.67 348.274 266.244 350.43 265.412 352.442C264.581 354.454 263.36 356.282 261.821 357.821C260.282 359.361 258.454 360.581 256.442 361.412C254.43 362.244 252.273 362.669 250.096 362.666H110.221V156.443H250.096C252.273 156.44 254.429 156.866 256.441 157.697C258.453 158.528 260.281 159.749 261.821 161.288C263.36 162.827 264.58 164.655 265.412 166.667C266.243 168.679 266.669 170.835 266.665 173.012H266.666Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M259.555 173.012V346.097C259.558 348.274 259.132 350.43 258.301 352.442C257.47 354.454 256.249 356.282 254.71 357.821C253.171 359.361 251.342 360.581 249.33 361.412C247.318 362.244 245.162 362.669 242.985 362.666H110.221V156.443H242.985C245.162 156.44 247.318 156.866 249.33 157.697C251.342 158.528 253.17 159.749 254.709 161.288C256.249 162.827 257.469 164.655 258.3 166.667C259.132 168.679 259.558 170.835 259.554 173.012H259.555Z"
      fill="black"
    />
    <path
      d="M242.964 156.443H77.0377C67.874 156.443 60.4453 163.872 60.4453 173.036V338.962C60.4453 348.126 67.874 355.554 77.0377 355.554H242.964C252.128 355.554 259.556 348.126 259.556 338.962V173.036C259.556 163.872 252.128 156.443 242.964 156.443Z"
      fill="#0078D4"
    />
    <path
      d="M192.606 219.599H146.049V246.825H189.749V264.273H146.049V292.551H195.088V309.927H124.915V202.072H192.606V219.599Z"
      fill="white"
    />
  </svg>
);

const bigtincan = props => (
  <svg
    width="105"
    height="30"
    viewBox="0 0 105 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.752 0C9.17 0 5.685 1.86 3.765 5.184.903 10.142 2.602 16.481 7.56 19.344a10.362 10.362 0 0 0 14.16-3.794c2.862-4.958 1.163-11.297-3.794-14.16A10.32 10.32 0 0 0 12.752 0zm0 0v.667c1.692 0 3.365.45 4.84 1.3 4.63 2.675 6.223 8.618 3.55 13.25a9.736 9.736 0 0 1-8.41 4.85 9.694 9.694 0 0 1-4.84-1.301c-4.63-2.674-6.223-8.617-3.55-13.248a9.735 9.735 0 0 1 8.41-4.851V0z"
      fill="#B5B3A5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.219 2.915c-2.075 0-4.177.529-6.103 1.64C.267 7.932-1.736 15.411 1.64 21.26a12.223 12.223 0 0 0 16.704 4.476c5.849-3.377 7.853-10.855 4.476-16.704a12.222 12.222 0 0 0-10.601-6.116zm0 0v2c3.649 0 7.047 1.96 8.869 5.116 2.82 4.884 1.14 11.152-3.744 13.972a10.222 10.222 0 0 1-5.102 1.372c-3.65 0-7.048-1.96-8.87-5.116-2.82-4.884-1.14-11.152 3.744-13.972a10.222 10.222 0 0 1 5.103-1.372v-2z"
      fill="#B5B3A5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.412 4.195c-7.109 0-12.872 5.763-12.872 12.872s5.763 12.872 12.872 12.872c7.108 0 12.871-5.763 12.871-12.872S24.52 4.195 17.412 4.195zm0 3.334c5.259 0 9.538 4.279 9.538 9.538 0 5.26-4.279 9.538-9.538 9.538-5.26 0-9.539-4.279-9.539-9.538 0-5.26 4.28-9.538 9.539-9.538z"
      fill="#F26724"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.899 20.247c0-.298-.054-.589-.16-.872a2.43 2.43 0 0 0-.448-.752 2.166 2.166 0 0 0-.68-.52 1.885 1.885 0 0 0-.84-.192h-4.608v4.656h4.496c.32 0 .616-.064.888-.192s.506-.301.704-.52c.197-.218.354-.466.472-.744.117-.277.176-.565.176-.864zm-6.736-7.568v4.544h4.16c.309 0 .592-.064.848-.192s.477-.296.664-.504c.186-.208.333-.45.44-.728.106-.277.16-.56.16-.848 0-.309-.051-.6-.152-.872a2.403 2.403 0 0 0-.416-.72 1.977 1.977 0 0 0-.632-.496 1.8 1.8 0 0 0-.816-.184h-4.256zm7.552 7.68c0 .416-.08.803-.24 1.16a2.962 2.962 0 0 1-1.632 1.56 3.16 3.16 0 0 1-1.184.224h-5.312v-11.36h5.296c.394 0 .752.086 1.072.256.32.171.592.392.816.664.224.272.397.582.52.928.122.347.184.696.184 1.048 0 .576-.144 1.104-.432 1.584-.288.48-.688.832-1.2 1.056.65.192 1.165.552 1.544 1.08.378.528.568 1.128.568 1.8zM46.715 23.303h.8v-8.32h-.8v8.32zm0-10.208h.8v-1.472h-.8v1.472zM53.563 22.743c.352 0 .693-.066 1.024-.2.33-.133.632-.307.904-.52.272-.213.498-.453.68-.72.18-.267.288-.533.32-.8v-2.736a3.598 3.598 0 0 0-1.24-1.584 3.635 3.635 0 0 0-.88-.456 2.823 2.823 0 0 0-.952-.168c-.502 0-.95.107-1.344.32-.395.214-.728.49-1 .832-.272.341-.48.728-.624 1.16a4.1 4.1 0 0 0-.216 1.304c0 .48.085.933.256 1.36.17.427.408.805.712 1.136.304.33.656.592 1.056.784.4.192.834.288 1.304.288m-.192.688a3.49 3.49 0 0 1-1.584-.36c-.48-.24-.896-.56-1.248-.96a4.378 4.378 0 0 1-.816-1.368 4.476 4.476 0 0 1-.288-1.584c0-.566.093-1.11.28-1.632.186-.523.45-.984.792-1.384.34-.4.749-.718 1.224-.952a3.474 3.474 0 0 1 1.56-.352c.725 0 1.357.19 1.896.568.538.379 1 .84 1.383 1.384v-1.808h.72v8.48c0 .565-.106 1.061-.32 1.488a3.105 3.105 0 0 1-.855 1.064 3.73 3.73 0 0 1-1.248.64 5.102 5.102 0 0 1-1.496.216c-.48 0-.913-.046-1.296-.136a3.869 3.869 0 0 1-1.016-.384 3.355 3.355 0 0 1-.784-.608c-.23-.24-.43-.504-.6-.792l.544-.368c.33.565.779.979 1.344 1.24a4.251 4.251 0 0 0 1.808.392c.426 0 .829-.06 1.208-.176.378-.117.709-.29.991-.52.283-.23.507-.515.673-.856.165-.341.248-.741.248-1.2v-1.824a3.965 3.965 0 0 1-1.36 1.296 3.442 3.442 0 0 1-1.76.496M63.498 22.904a4.977 4.977 0 0 0-.215.12c-.102.059-.23.115-.385.168a4.705 4.705 0 0 1-.52.144c-.191.042-.4.064-.623.064-.224 0-.435-.032-.633-.096a1.459 1.459 0 0 1-.88-.752 1.413 1.413 0 0 1-.136-.64V15.64h-1.168v-.656h1.168v-2.848h.8v2.848h1.953v.656h-1.952v6.08c0 .31.106.541.32.696.213.154.458.232.736.232.33 0 .615-.056.855-.168.24-.112.387-.184.44-.216l.24.64zM64.843 23.303h.8v-8.32h-.8v8.32zm0-10.208h.8v-1.472h-.8v1.472zM74.906 23.304h-.8v-4.64c0-1.078-.152-1.862-.456-2.352-.304-.49-.792-.736-1.464-.736-.352 0-.702.064-1.048.192a3.43 3.43 0 0 0-.96.544c-.293.235-.552.51-.776.824-.224.315-.39.654-.496 1.016v5.152h-.8v-8.32h.736v1.984c.17-.32.384-.61.64-.872.256-.261.539-.486.848-.672a4.097 4.097 0 0 1 2.096-.584c.907 0 1.547.318 1.92.952.373.635.56 1.544.56 2.728v4.784zM76.714 19.11c0-.585.101-1.14.304-1.663.203-.523.488-.976.856-1.36a4.103 4.103 0 0 1 1.304-.912 3.991 3.991 0 0 1 1.648-.336c.757 0 1.422.17 1.992.512.57.341 1.005.816 1.304 1.424l-.784.256a2.677 2.677 0 0 0-1.056-1.08 2.985 2.985 0 0 0-1.504-.392c-.459 0-.886.09-1.28.272a3.194 3.194 0 0 0-1.032.752c-.293.32-.523.696-.688 1.128a3.884 3.884 0 0 0-.248 1.4c0 .502.088.973.264 1.416.176.443.41.827.704 1.152a3.34 3.34 0 0 0 1.032.776c.394.192.816.288 1.264.288.288 0 .573-.042.856-.128.282-.085.544-.197.784-.336s.448-.301.624-.488.296-.381.36-.584l.784.224a2.6 2.6 0 0 1-.488.808c-.219.25-.477.466-.776.648a4.062 4.062 0 0 1-2.096.576 3.877 3.877 0 0 1-1.632-.344 4.032 4.032 0 0 1-1.304-.944 4.593 4.593 0 0 1-.872-1.384 4.4 4.4 0 0 1-.32-1.68M88.234 22.824c.619 0 1.19-.115 1.712-.344.523-.23.912-.541 1.168-.936.182-.213.272-.427.272-.64v-1.472a7.17 7.17 0 0 0-2.496-.448c-.832 0-1.504.17-2.016.512-.512.341-.768.79-.768 1.344 0 .277.053.538.16.784.107.245.256.456.448.632s.419.314.68.416c.262.101.542.152.84.152m-.16.64a2.9 2.9 0 0 1-1.96-.744 2.41 2.41 0 0 1-.584-.816 2.49 2.49 0 0 1-.208-1.016c0-.363.086-.694.256-.992.17-.299.41-.558.72-.776.31-.219.675-.39 1.096-.512a5.004 5.004 0 0 1 1.4-.184c.448 0 .902.04 1.36.12.459.08.87.19 1.232.328v-.816c0-.79-.224-1.416-.672-1.88-.448-.464-1.056-.696-1.824-.696-.416 0-.85.085-1.304.256-.453.17-.91.416-1.368.736l-.32-.544c1.078-.726 2.09-1.088 3.04-1.088 1.003 0 1.795.29 2.376.872.581.581.872 1.384.872 2.408v4.064c0 .267.112.4.336.4v.72a.776.776 0 0 1-.152.016h-.136a.804.804 0 0 1-.528-.2.645.645 0 0 1-.24-.52v-.688a3.75 3.75 0 0 1-1.464 1.152 4.64 4.64 0 0 1-1.928.4M101.433 23.304h-.799v-4.64c0-1.078-.152-1.862-.457-2.352-.303-.49-.792-.736-1.464-.736-.351 0-.701.064-1.047.192a3.43 3.43 0 0 0-.96.544c-.294.235-.553.51-.776.824-.225.315-.39.654-.497 1.016v5.152h-.8v-8.32h.737v1.984c.17-.32.383-.61.64-.872.255-.261.538-.486.847-.672a4.095 4.095 0 0 1 2.097-.584c.906 0 1.546.318 1.919.952.374.635.56 1.544.56 2.728v4.784zM104.623 11.459h.333v1.886h-.246V11.84l-.594 1.226h-.213l-.593-1.226v1.506h-.247V11.46h.327l.62 1.3.613-1.3zm-1.867.24h-.633v1.646h-.253V11.7h-.634v-.254h1.52v.254z"
      fill="#000"
    />
  </svg>
);

const engagementHub = props => (
  <svg
    width="1042"
    height="1132"
    viewBox="0 0 1042 1132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M203.516 1132L1042 980.551V151.449L203.516 0V1132ZM0 1074.99L113.969 1053.95V78.0537L0 57.0072V1074.99ZM648.827 893.755C606.673 898.887 567.477 894.488 531.24 880.558C495.742 866.629 465.236 845.001 439.722 815.676C414.208 786.351 394.055 750.061 379.264 706.806C365.213 663.551 358.188 615.164 358.188 561.645C358.188 508.127 365.213 459.74 379.264 416.485C394.055 373.963 414.208 337.856 439.722 308.164C465.236 278.472 495.742 256.662 531.24 242.732C567.477 228.803 606.673 224.77 648.827 230.635C700.594 236.501 747.555 253.729 789.709 282.321C831.863 310.914 864.402 346.837 887.328 390.092L791.927 447.276C776.397 420.151 756.43 398.156 732.025 381.294C707.62 364.432 679.887 354.902 648.827 352.702C598.538 348.303 556.754 365.532 523.475 404.388C490.195 443.244 473.556 495.663 473.556 561.645C473.556 629.827 490.565 682.796 524.584 720.552C558.603 758.308 600.017 774.987 648.827 770.588C679.148 768.389 706.696 759.042 731.47 742.546C756.245 726.05 776.767 704.24 793.037 677.114L884 740.896C858.856 781.952 826.131 816.043 785.826 843.169C745.521 870.294 699.855 887.157 648.827 893.755Z"
      fill="#333F48"
    />
  </svg>
);

const learningHubSVG = props => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="46" height="46" rx="2" fill="#FF4A7E" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.695 27.016a.801.801 0 0 1-.316.668c-.07.257-.106.691-.106 1.3 0 .61.036 1.043.106 1.301.21.188.316.41.316.668v.563a.814.814 0 0 1-.246.597.814.814 0 0 1-.597.246H18.32c-.937 0-1.734-.328-2.39-.984-.657-.656-.985-1.453-.985-2.39v-11.25c0-.938.328-1.735.985-2.391.656-.656 1.453-.985 2.39-.985h11.532c.234 0 .433.082.597.246a.813.813 0 0 1 .246.598v11.813zm-11.25-7.946v.703c0 .047.024.094.07.141.047.047.094.07.141.07h7.453c.047 0 .094-.023.141-.07.047-.047.07-.094.07-.14v-.704c0-.047-.023-.093-.07-.14-.047-.047-.094-.07-.14-.07h-7.454c-.047 0-.093.023-.14.07-.047.047-.07.093-.07.14zm0 2.25v.703c0 .047.024.094.07.141.047.047.094.07.141.07h7.453c.047 0 .094-.023.141-.07.047-.047.07-.094.07-.14v-.704c0-.047-.023-.093-.07-.14-.047-.047-.094-.07-.14-.07h-7.454c-.047 0-.093.023-.14.07-.047.047-.07.093-.07.14zm8.895 8.79c-.024-.305-.035-.68-.035-1.126 0-.445.011-.82.035-1.125H18.32c-.304 0-.568.112-.79.334a1.08 1.08 0 0 0-.335.791c0 .305.112.569.334.791.223.223.487.334.791.334h10.02z"
      fill="#fff"
    />
  </svg>
);

const emptySearchResults = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 120" {...props}>
    <defs>
      <circle id="a" cx="27.5" cy="27.5" r="27.5" />
      <path
        id="c"
        d="M9.2 2.77l9.8-.14a2 2 0 0 1 2.03 2.03l-.19 13.64a7.1 7.1 0 0 1-7 7 6.72 6.72 0 0 1-6.8-6.81l.18-13.75A2 2 0 0 1 9.2 2.77z"
      />
      <path
        id="e"
        d="M20.15 5l12.51 23.6a3 3 0 0 1-2.65 4.4H5a3 3 0 0 1-2.65-4.4L14.85 5a3 3 0 0 1 5.3 0z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(21 24)">
        <path
          fill="#EEEEEE"
          d="M157.1 17H96.53a1.53 1.53 0 0 1-.88-2.77L98 12.55a10.08 10.08 0 0 1 3.4-1.55l7.04-1.77c1.57-.4 3.02-1.16 4.23-2.24l2.76-2.45a10.08 10.08 0 0 1 6.7-2.54h4.05c1.94 0 3.8.76 5.18 2.12a7.4 7.4 0 0 0 5.18 2.11h2.17c2.64 0 5.17 1.04 7.06 2.9l1.94 1.9a8.53 8.53 0 0 0 4.93 2.37l.2.03c1.74.21 3.4.88 4.81 1.95a.9.9 0 0 1-.54 1.62zM.96 16h64.4a1.63 1.63 0 0 0 .95-2.96l-2.5-1.78A10.76 10.76 0 0 0 60.2 9.6l-7.47-1.88a10.76 10.76 0 0 1-4.52-2.4l-2.92-2.59A10.76 10.76 0 0 0 38.14 0h-4.28c-2.07 0-4.05.81-5.52 2.26a7.85 7.85 0 0 1-5.5 2.26h-2.29a10.7 10.7 0 0 0-7.54 3.09l-2.05 2.02a9.05 9.05 0 0 1-5.24 2.53l-.21.03c-1.87.23-3.63.95-5.13 2.08A.96.96 0 0 0 .96 16z"
        />
        <path
          fill="#F5F5F5"
          d="M117.93 91.75A46.66 46.66 0 0 0 124 68.6C124 42.86 103.4 22 78 22S32 42.86 32 68.6A47.07 47.07 0 0 0 38.21 92c8.32-.1 70.05 0 79.72-.25z"
        />
        <g fill="#24283D" transform="translate(13 90)">
          <rect width="110" height="2" x="10" rx="1" />
          <rect width="4" height="2" x="122" rx="1" />
          <rect width="2" height="2" x="128" rx="1" />
          <rect width="4" height="2" x="4" rx="1" />
          <rect width="2" height="2" rx="1" />
        </g>
      </g>
      <g transform="translate(65 46)">
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M49.44 43.22l6.28 6.27-4.68 4.68-6.15-6.12a20.6 20.6 0 0 0 2.69-2.56c.56-.67 1.18-1.42 1.86-2.27h0z"
        />
        <mask id="b" fill="white">
          <use xlinkHref="#a" />
        </mask>
        <use fill="#FFFFFF" xlinkHref="#a" />
        <circle
          cx="26"
          cy="26.25"
          r="26.5"
          stroke="#000000"
          strokeOpacity=".15"
          strokeWidth="2"
          mask="url(#b)"
        />
        <circle
          cx="27.5"
          cy="27.5"
          r="26.5"
          stroke="#24283D"
          strokeWidth="2"
          mask="url(#b)"
        />
        <g transform="translate(8 9)">
          <circle cx="19" cy="19" r="19" fill="#F5F5F5" />
          <circle cx="19" cy="19" r="18" stroke="#24283D" strokeWidth="2" />
        </g>
        <g transform="translate(47 45)">
          <mask id="d" fill="white">
            <use xlinkHref="#c" />
          </mask>
          <use fill="#F4854F" transform="rotate(-45 14 14)" xlinkHref="#c" />
          <path
            stroke="#000000"
            strokeOpacity=".15"
            strokeWidth="2"
            d="M17.54 3.63a1 1 0 0 1 1.02.98h0l-.2 13.67a6.08 6.08 0 0 1-6 6.02 5.7 5.7 0 0 1-5.8-5.63h0l.19-13.91a1 1 0 0 1 .98-.99h0z"
            mask="url(#d)"
            transform="rotate(-45 12.524 14)"
          />
          <path
            stroke="#24283D"
            strokeWidth="2"
            d="M19.02 3.63a1 1 0 0 1 1.01.98h0l-.19 13.67a6.08 6.08 0 0 1-6.01 6.02 5.7 5.7 0 0 1-5.8-5.63h0l.2-13.91a1 1 0 0 1 .98-.99h0z"
            mask="url(#d)"
            transform="rotate(-45 14 14)"
          />
        </g>
        <path
          stroke="#24283D"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M24.29 17.3a11.3 11.3 0 0 0-7.5 14.1"
        />
      </g>
      <g transform="translate(76 83)">
        <mask id="f" fill="white">
          <use xlinkHref="#e" />
        </mask>
        <use fill="#FFFFFF" xlinkHref="#e" />
        <path
          stroke="#080808"
          strokeOpacity=".15"
          strokeWidth="2"
          d="M16.27 1.33l14.17 26.73A2 2 0 0 1 28.68 31H.32a2 2 0 0 1-1.76-2.94L12.73 1.33a2 2 0 0 1 3.54 0z"
          mask="url(#f)"
        />
        <path
          stroke="#24283D"
          strokeWidth="2"
          d="M16.91 4.5a2 2 0 0 1 2.36.97h0l12.51 23.6A2 2 0 0 1 30.01 32h0H5a2 2 0 0 1-1.77-2.94h0l12.51-23.6a2 2 0 0 1 1.18-.97z"
          mask="url(#f)"
        />
        <path
          fill="#FF854B"
          stroke="#24283D"
          strokeWidth="1.2"
          d="M18.27 23h-.54a1.2 1.2 0 0 1-1.2-1.14l-.44-8.97A1.8 1.8 0 0 1 17.9 11h.22a1.8 1.8 0 0 1 1.8 1.89l-.44 8.97a1.2 1.2 0 0 1-1.2 1.14zM16 27c0-.66.17-1.16.51-1.5.35-.33.85-.5 1.5-.5a2 2 0 0 1 1.47.52c.35.34.52.84.52 1.48a2 2 0 0 1-.53 1.46c-.35.36-.83.54-1.46.54-.64 0-1.13-.17-1.48-.52A2 2 0 0 1 16 27z"
        />
      </g>
    </g>
  </svg>
);

const bigtincanAnalyticsSVG = props => (
  <svg
    width="200"
    height="120"
    viewBox="0 0 200 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clip
      Rule="evenodd"
      d="M139.929 116c1.363-2.408 2.521-5.197 3.448-7.85A47.066 47.066 0 0 0 146 92.6c0-25.736-20.595-46.6-46-46.6S54 66.864 54 92.6c0 5.458.926 10.696 2.628 15.563A46.644 46.644 0 0 0 60.211 116h79.718z"
      fill="#F5F5F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176.849 44.023c1.267.958.59 2.977-.998 2.977h-54.075c-2.807 0-3.957-3.605-1.669-5.23.292-.207.62-.358.967-.446l8.352-2.097a10.076 10.076 0 0 0 4.235-2.236l2.762-2.451a10.083 10.083 0 0 1 6.69-2.54h4.056c1.937 0 3.797.76 5.179 2.117a7.388 7.388 0 0 0 5.178 2.118h2.171a10.08 10.08 0 0 1 7.063 2.887l1.696 1.666a9.518 9.518 0 0 0 5.503 2.655l2.094.258c.29.035.564.147.796.322zM24.285 41.826C22.938 42.85 23.66 45 25.354 45H82.85c2.992 0 4.22-3.841 1.783-5.578a3.073 3.073 0 0 0-1.033-.477l-8.867-2.233a10.756 10.756 0 0 1-4.524-2.395l-2.917-2.596A10.755 10.755 0 0 0 60.143 29h-4.287a7.855 7.855 0 0 0-5.511 2.258 7.854 7.854 0 0 1-5.512 2.259h-2.28c-2.825 0-5.536 1.11-7.548 3.092l-1.796 1.769a10.1 10.1 0 0 1-5.847 2.827l-2.226.276a1.768 1.768 0 0 0-.85.345z"
      fill="#EEE"
    />
    <rect x="40" y="114" width="120" height="2" rx="1" fill="#24283D" />
    <rect x="162" y="114" width="4" height="2" rx="1" fill="#24283D" />
    <rect x="168" y="114" width="2" height="2" rx="1" fill="#24283D" />
    <rect x="34" y="114" width="4" height="2" rx="1" fill="#24283D" />
    <rect x="30" y="114" width="2" height="2" rx="1" fill="#24283D" />
    <rect
      x="83.503"
      y="35.054"
      width="4"
      height="80"
      rx="2"
      transform="rotate(7 83.503 35.054)"
      fill="#FF854B"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path fill="#000" fillOpacity=".2" d="M75.614 97h4v2h-4z" />
    <rect
      x="83.503"
      y="35.054"
      width="4"
      height="80"
      rx="2"
      transform="rotate(7 83.503 35.054)"
      stroke="#24283D"
      strokeWidth="2"
    />
    <rect
      x="111.754"
      y="35.542"
      width="4"
      height="80"
      rx="2"
      transform="rotate(-7 111.754 35.542)"
      fill="#FF854B"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path fill="#000" fillOpacity=".2" d="M119.614 97h4v2h-4z" />
    <rect
      x="111.754"
      y="35.542"
      width="4"
      height="80"
      rx="2"
      transform="rotate(-7 111.754 35.542)"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path
      d="M73.073 37.904c.096-1.042.164-1.766.26-2.328.095-.55.206-.867.349-1.107a3 3 0 0 1 1.292-1.179c.252-.12.578-.201 1.135-.245.568-.044 1.295-.045 2.341-.045h42.327c1.046 0 1.773 0 2.342.045.557.044.882.125 1.135.245a3 3 0 0 1 1.292 1.179c.143.24.253.557.348 1.107.097.562.164 1.286.26 2.328l4.819 52.2c.113 1.229.192 2.088.197 2.759.005.66-.064 1.038-.187 1.324a3.004 3.004 0 0 1-1.32 1.447c-.273.15-.644.253-1.302.309-.668.056-1.531.057-2.765.057H73.632c-1.234 0-2.098 0-2.766-.057-.657-.056-1.028-.16-1.301-.309a3 3 0 0 1-1.32-1.447c-.123-.286-.193-.664-.188-1.324.006-.67.084-1.53.198-2.76l4.818-52.2z"
      fill="#fff"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path
      d="M119.614 33h2.671a2 2 0 0 1 1.992 1.822l5.142 57.5a2 2 0 0 1-1.992 2.178H70.614a2.5 2.5 0 0 1-2.5-2.5"
      stroke="#E5E5E5"
      strokeWidth="2"
    />
    <path
      d="M73.073 37.904c.096-1.042.164-1.766.26-2.328.095-.55.206-.867.349-1.107a3 3 0 0 1 1.292-1.179c.252-.12.578-.201 1.135-.245.568-.044 1.295-.045 2.341-.045h42.327c1.046 0 1.773 0 2.342.045.557.044.882.125 1.135.245a3 3 0 0 1 1.292 1.179c.143.24.253.557.348 1.107.097.562.164 1.286.26 2.328l4.819 52.2c.113 1.229.192 2.088.197 2.759.005.66-.064 1.038-.187 1.324a3.004 3.004 0 0 1-1.32 1.447c-.273.15-.644.253-1.302.309-.668.056-1.531.057-2.765.057H73.632c-1.234 0-2.098 0-2.766-.057-.657-.056-1.028-.16-1.301-.309a3 3 0 0 1-1.32-1.447c-.123-.286-.193-.664-.188-1.324.006-.67.084-1.53.198-2.76l4.818-52.2z"
      stroke="#24283D"
      strokeWidth="2"
    />
    <path
      d="m79.114 75 6-8 7 8 8-13.5 8 9 12-19"
      stroke="#24283D"
      strokeWidth="2"
    />
    <circle
      cx="79.114"
      cy="74.5"
      r="2"
      fill="#FF854B"
      stroke="#24283D"
      strokeWidth="2"
    />
    <circle
      cx="119.114"
      cy="53"
      r="2"
      fill="#FF854B"
      stroke="#24283D"
      strokeWidth="2"
    />
  </svg>
);

export default class SVGIcon extends Component {
  static propTypes = {
    type: PropTypes.oneOf([
      '3d-model',
      'app',
      'cad',
      'excel',
      'file',
      'folder',
      'potx',
      'powerpoint',
      'project',
      'scrollmotion',
      'word',
      'visio',
      'toolbox',
      'trash',
      'brokenFile',
      'sharedFile',
      'storyEmpty',
      'uploadingFile',
      'people',
      'noApplications',
      'warning',
      'email',
      'webLink',
      'salesAI',
      'microsoftExchange',
      'bigtincan',
      'engagementHub',
      'learningHub',
      'emptySearchResults',
      'bigtincanAnalytics',
    ]),
    className: PropTypes.string,
    style: PropTypes.object,
  };

  render() {
    const cx = classNames.bind(styles);
    const classes = cx(
      {
        FolderSVG: this.props.type === 'folder',
      },
      this.props.className
    );

    let Comp;
    switch (this.props.type) {
      case '3d-model':
        Comp = UsdzSVG;
        break;
      case 'app':
        Comp = BtcSVG;
        break;
      case 'cad':
        Comp = CadSVG;
        break;
      case 'excel':
        Comp = ExcelSVG;
        break;
      case 'folder':
        Comp = FolderSVG;
        break;
      case 'potx':
      case 'powerpoint':
        Comp = PowerpointSVG;
        break;
      case 'project':
        Comp = ProjectSVG;
        break;
      case 'scrollmotion':
        Comp = ScrollmotionSVG;
        break;
      case 'word':
        Comp = WordSVG;
        break;
      case 'visio':
        Comp = VisioSVG;
        break;
      case 'toolbox':
        Comp = Toolbox;
        break;
      case 'brokenFile':
        Comp = BrokenFile;
        break;
      case 'sharedFile':
        Comp = SharedFile;
        break;
      case 'storyEmpty':
        Comp = StoryEmpty;
        break;
      case 'file':
        Comp = file;
        break;
      case 'trash':
        Comp = trash;
        break;
      case 'uploadingFile':
        Comp = uploadingFile;
        break;
      case 'people':
        Comp = people;
        break;
      case 'noApplications':
        Comp = noApplications;
        break;
      case 'warning':
        Comp = warning;
        break;
      case 'email':
        Comp = email;
        break;
      case 'webLink':
        Comp = webLink;
        break;
      case 'salesAI':
        Comp = salesAI;
        break;
      case 'microsoftExchange':
        Comp = microsoftExchange;
        break;
      case 'bigtincan':
        Comp = bigtincan;
        break;
      case 'engagementHub':
        Comp = engagementHub;
        break;
      case 'learningHub':
        Comp = learningHubSVG;
        break;
      case 'emptySearchResults':
        Comp = emptySearchResults;
        break;
      case 'bigtincanAnalytics':
        Comp = bigtincanAnalyticsSVG;
        break;
      default:
        return false;
    }

    return <Comp {...this.props} className={classes} />;
  }
}
